/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CalendarDay: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AuthenticatedItem = User;

export type BerufsTyp = {
  __typename?: 'BerufsTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  weiblich?: Maybe<Scalars['String']['output']>;
};

export type BerufsTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  weiblich?: InputMaybe<Scalars['String']['input']>;
};

export type BerufsTypManyRelationFilter = {
  every?: InputMaybe<BerufsTypWhereInput>;
  none?: InputMaybe<BerufsTypWhereInput>;
  some?: InputMaybe<BerufsTypWhereInput>;
};

export type BerufsTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  weiblich?: InputMaybe<OrderDirection>;
};

export type BerufsTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<BerufsTypWhereUniqueInput>>;
  create?: InputMaybe<Array<BerufsTypCreateInput>>;
};

export type BerufsTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<BerufsTypWhereUniqueInput>>;
  create?: InputMaybe<Array<BerufsTypCreateInput>>;
  disconnect?: InputMaybe<Array<BerufsTypWhereUniqueInput>>;
  set?: InputMaybe<Array<BerufsTypWhereUniqueInput>>;
};

export type BerufsTypUpdateArgs = {
  data: BerufsTypUpdateInput;
  where: BerufsTypWhereUniqueInput;
};

export type BerufsTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  weiblich?: InputMaybe<Scalars['String']['input']>;
};

export type BerufsTypWhereInput = {
  AND?: InputMaybe<Array<BerufsTypWhereInput>>;
  NOT?: InputMaybe<Array<BerufsTypWhereInput>>;
  OR?: InputMaybe<Array<BerufsTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  weiblich?: InputMaybe<StringFilter>;
};

export type BerufsTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type CalendarDayNullableFilter = {
  equals?: InputMaybe<Scalars['CalendarDay']['input']>;
  gt?: InputMaybe<Scalars['CalendarDay']['input']>;
  gte?: InputMaybe<Scalars['CalendarDay']['input']>;
  in?: InputMaybe<Array<Scalars['CalendarDay']['input']>>;
  lt?: InputMaybe<Scalars['CalendarDay']['input']>;
  lte?: InputMaybe<Scalars['CalendarDay']['input']>;
  not?: InputMaybe<CalendarDayNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['CalendarDay']['input']>>;
};

export type CopyrightTyp = {
  __typename?: 'CopyrightTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CopyrightTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CopyrightTypManyRelationFilter = {
  every?: InputMaybe<CopyrightTypWhereInput>;
  none?: InputMaybe<CopyrightTypWhereInput>;
  some?: InputMaybe<CopyrightTypWhereInput>;
};

export type CopyrightTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type CopyrightTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<CopyrightTypWhereUniqueInput>>;
  create?: InputMaybe<Array<CopyrightTypCreateInput>>;
};

export type CopyrightTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<CopyrightTypWhereUniqueInput>>;
  create?: InputMaybe<Array<CopyrightTypCreateInput>>;
  disconnect?: InputMaybe<Array<CopyrightTypWhereUniqueInput>>;
  set?: InputMaybe<Array<CopyrightTypWhereUniqueInput>>;
};

export type CopyrightTypUpdateArgs = {
  data: CopyrightTypUpdateInput;
  where: CopyrightTypWhereUniqueInput;
};

export type CopyrightTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CopyrightTypWhereInput = {
  AND?: InputMaybe<Array<CopyrightTypWhereInput>>;
  NOT?: InputMaybe<Array<CopyrightTypWhereInput>>;
  OR?: InputMaybe<Array<CopyrightTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CopyrightTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInitialUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type Eigentum = {
  __typename?: 'Eigentum';
  datum?: Maybe<Scalars['CalendarDay']['output']>;
  description?: Maybe<Eigentum_Description_Document>;
  displayName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Gruppe>>;
  groupsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Eigentum_Notes_Document>;
  persons?: Maybe<Array<Person>>;
  personsCount?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Eigentum_Sources_Document>;
  weblinks?: Maybe<Eigentum_Weblinks_Document>;
};


export type EigentumGroupsArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type EigentumGroupsCountArgs = {
  where?: GruppeWhereInput;
};


export type EigentumPersonsArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type EigentumPersonsCountArgs = {
  where?: PersonWhereInput;
};

export type EigentumCreateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  groups?: InputMaybe<GruppeRelateToManyForCreateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  persons?: InputMaybe<PersonRelateToManyForCreateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type EigentumManyRelationFilter = {
  every?: InputMaybe<EigentumWhereInput>;
  none?: InputMaybe<EigentumWhereInput>;
  some?: InputMaybe<EigentumWhereInput>;
};

export type EigentumOrderByInput = {
  datum?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type EigentumRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<EigentumWhereUniqueInput>>;
  create?: InputMaybe<Array<EigentumCreateInput>>;
};

export type EigentumRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<EigentumWhereUniqueInput>>;
  create?: InputMaybe<Array<EigentumCreateInput>>;
  disconnect?: InputMaybe<Array<EigentumWhereUniqueInput>>;
  set?: InputMaybe<Array<EigentumWhereUniqueInput>>;
};

export type EigentumUpdateArgs = {
  data: EigentumUpdateInput;
  where: EigentumWhereUniqueInput;
};

export type EigentumUpdateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  groups?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  persons?: InputMaybe<PersonRelateToManyForUpdateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type EigentumWhereInput = {
  AND?: InputMaybe<Array<EigentumWhereInput>>;
  NOT?: InputMaybe<Array<EigentumWhereInput>>;
  OR?: InputMaybe<Array<EigentumWhereInput>>;
  datum?: InputMaybe<CalendarDayNullableFilter>;
  groups?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  persons?: InputMaybe<PersonManyRelationFilter>;
};

export type EigentumWhereUniqueInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Eigentum_Description_Document = {
  __typename?: 'Eigentum_description_Document';
  document: Scalars['JSON']['output'];
};


export type Eigentum_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Eigentum_Notes_Document = {
  __typename?: 'Eigentum_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Eigentum_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Eigentum_Sources_Document = {
  __typename?: 'Eigentum_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Eigentum_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Eigentum_Weblinks_Document = {
  __typename?: 'Eigentum_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Eigentum_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Entstehungszeit = {
  __typename?: 'Entstehungszeit';
  datum?: Maybe<Scalars['CalendarDay']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  zeitspanne?: Maybe<Zeitspanne>;
};

export type EntstehungszeitCreateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  zeitspanne?: InputMaybe<ZeitspanneRelateToOneForCreateInput>;
};

export type EntstehungszeitOrderByInput = {
  datum?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type EntstehungszeitRelateToOneForCreateInput = {
  connect?: InputMaybe<EntstehungszeitWhereUniqueInput>;
  create?: InputMaybe<EntstehungszeitCreateInput>;
};

export type EntstehungszeitRelateToOneForUpdateInput = {
  connect?: InputMaybe<EntstehungszeitWhereUniqueInput>;
  create?: InputMaybe<EntstehungszeitCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntstehungszeitUpdateArgs = {
  data: EntstehungszeitUpdateInput;
  where: EntstehungszeitWhereUniqueInput;
};

export type EntstehungszeitUpdateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  zeitspanne?: InputMaybe<ZeitspanneRelateToOneForUpdateInput>;
};

export type EntstehungszeitWhereInput = {
  AND?: InputMaybe<Array<EntstehungszeitWhereInput>>;
  NOT?: InputMaybe<Array<EntstehungszeitWhereInput>>;
  OR?: InputMaybe<Array<EntstehungszeitWhereInput>>;
  datum?: InputMaybe<CalendarDayNullableFilter>;
  id?: InputMaybe<IdFilter>;
  zeitspanne?: InputMaybe<ZeitspanneWhereInput>;
};

export type EntstehungszeitWhereUniqueInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Ereignis = {
  __typename?: 'Ereignis';
  characters?: Maybe<Array<Person>>;
  charactersCount?: Maybe<Scalars['Int']['output']>;
  contains?: Maybe<Array<Ereignis>>;
  containsCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Ereignis_Description_Document>;
  descriptionAuthor?: Maybe<Array<Person>>;
  descriptionAuthorCount?: Maybe<Scalars['Int']['output']>;
  eigenschaften?: Maybe<Array<EreignisEigenschaft>>;
  eigenschaftenCount?: Maybe<Scalars['Int']['output']>;
  groupsOnEvent?: Maybe<Array<Gruppe>>;
  groupsOnEventCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Objekt>>;
  imagesCount?: Maybe<Scalars['Int']['output']>;
  locationOnEvent?: Maybe<Array<Ort>>;
  locationOnEventCount?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Ereignis_Notes_Document>;
  objectsOnEvent?: Maybe<Array<Objekt>>;
  objectsOnEventCount?: Maybe<Scalars['Int']['output']>;
  otherTitles?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<Array<Ereignis>>;
  partOfCount?: Maybe<Scalars['Int']['output']>;
  periodOfOrigin?: Maybe<Entstehungszeit>;
  personsOnEvent?: Maybe<Array<Person>>;
  personsOnEventCount?: Maybe<Scalars['Int']['output']>;
  place?: Maybe<Ort>;
  similarFrom?: Maybe<Array<Ereignis>>;
  similarFromCount?: Maybe<Scalars['Int']['output']>;
  similarTo?: Maybe<Array<Ereignis>>;
  similarToCount?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Ereignis_Sources_Document>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typen?: Maybe<Array<EreignisTyp>>;
  typenCount?: Maybe<Scalars['Int']['output']>;
  weblinks?: Maybe<Ereignis_Weblinks_Document>;
  zustaende?: Maybe<Array<Status>>;
  zustaendeCount?: Maybe<Scalars['Int']['output']>;
};


export type EreignisCharactersArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type EreignisCharactersCountArgs = {
  where?: PersonWhereInput;
};


export type EreignisContainsArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type EreignisContainsCountArgs = {
  where?: EreignisWhereInput;
};


export type EreignisDescriptionAuthorArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type EreignisDescriptionAuthorCountArgs = {
  where?: PersonWhereInput;
};


export type EreignisEigenschaftenArgs = {
  cursor?: InputMaybe<EreignisEigenschaftWhereUniqueInput>;
  orderBy?: Array<EreignisEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisEigenschaftWhereInput;
};


export type EreignisEigenschaftenCountArgs = {
  where?: EreignisEigenschaftWhereInput;
};


export type EreignisGroupsOnEventArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type EreignisGroupsOnEventCountArgs = {
  where?: GruppeWhereInput;
};


export type EreignisImagesArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type EreignisImagesCountArgs = {
  where?: ObjektWhereInput;
};


export type EreignisLocationOnEventArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type EreignisLocationOnEventCountArgs = {
  where?: OrtWhereInput;
};


export type EreignisObjectsOnEventArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type EreignisObjectsOnEventCountArgs = {
  where?: ObjektWhereInput;
};


export type EreignisPartOfArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type EreignisPartOfCountArgs = {
  where?: EreignisWhereInput;
};


export type EreignisPersonsOnEventArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type EreignisPersonsOnEventCountArgs = {
  where?: PersonWhereInput;
};


export type EreignisSimilarFromArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type EreignisSimilarFromCountArgs = {
  where?: EreignisWhereInput;
};


export type EreignisSimilarToArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type EreignisSimilarToCountArgs = {
  where?: EreignisWhereInput;
};


export type EreignisTypenArgs = {
  cursor?: InputMaybe<EreignisTypWhereUniqueInput>;
  orderBy?: Array<EreignisTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisTypWhereInput;
};


export type EreignisTypenCountArgs = {
  where?: EreignisTypWhereInput;
};


export type EreignisZustaendeArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type EreignisZustaendeCountArgs = {
  where?: StatusWhereInput;
};

export type EreignisCreateInput = {
  characters?: InputMaybe<PersonRelateToManyForCreateInput>;
  contains?: InputMaybe<EreignisRelateToManyForCreateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  descriptionAuthor?: InputMaybe<PersonRelateToManyForCreateInput>;
  eigenschaften?: InputMaybe<EreignisEigenschaftRelateToManyForCreateInput>;
  groupsOnEvent?: InputMaybe<GruppeRelateToManyForCreateInput>;
  images?: InputMaybe<ObjektRelateToManyForCreateInput>;
  locationOnEvent?: InputMaybe<OrtRelateToManyForCreateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectsOnEvent?: InputMaybe<ObjektRelateToManyForCreateInput>;
  otherTitles?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<EreignisRelateToManyForCreateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForCreateInput>;
  personsOnEvent?: InputMaybe<PersonRelateToManyForCreateInput>;
  place?: InputMaybe<OrtRelateToOneForCreateInput>;
  similarFrom?: InputMaybe<EreignisRelateToManyForCreateInput>;
  similarTo?: InputMaybe<EreignisRelateToManyForCreateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typen?: InputMaybe<EreignisTypRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForCreateInput>;
};

export type EreignisEigenschaft = {
  __typename?: 'EreignisEigenschaft';
  ereignisse?: Maybe<Array<Ereignis>>;
  ereignisseCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type EreignisEigenschaftEreignisseArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type EreignisEigenschaftEreignisseCountArgs = {
  where?: EreignisWhereInput;
};

export type EreignisEigenschaftCreateInput = {
  ereignisse?: InputMaybe<EreignisRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EreignisEigenschaftManyRelationFilter = {
  every?: InputMaybe<EreignisEigenschaftWhereInput>;
  none?: InputMaybe<EreignisEigenschaftWhereInput>;
  some?: InputMaybe<EreignisEigenschaftWhereInput>;
};

export type EreignisEigenschaftOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type EreignisEigenschaftRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<EreignisEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisEigenschaftCreateInput>>;
};

export type EreignisEigenschaftRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<EreignisEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisEigenschaftCreateInput>>;
  disconnect?: InputMaybe<Array<EreignisEigenschaftWhereUniqueInput>>;
  set?: InputMaybe<Array<EreignisEigenschaftWhereUniqueInput>>;
};

export type EreignisEigenschaftUpdateArgs = {
  data: EreignisEigenschaftUpdateInput;
  where: EreignisEigenschaftWhereUniqueInput;
};

export type EreignisEigenschaftUpdateInput = {
  ereignisse?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EreignisEigenschaftWhereInput = {
  AND?: InputMaybe<Array<EreignisEigenschaftWhereInput>>;
  NOT?: InputMaybe<Array<EreignisEigenschaftWhereInput>>;
  OR?: InputMaybe<Array<EreignisEigenschaftWhereInput>>;
  ereignisse?: InputMaybe<EreignisManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type EreignisEigenschaftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EreignisManyRelationFilter = {
  every?: InputMaybe<EreignisWhereInput>;
  none?: InputMaybe<EreignisWhereInput>;
  some?: InputMaybe<EreignisWhereInput>;
};

export type EreignisOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  otherTitles?: InputMaybe<OrderDirection>;
  subtitle?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type EreignisRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<EreignisWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisCreateInput>>;
};

export type EreignisRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<EreignisWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisCreateInput>>;
  disconnect?: InputMaybe<Array<EreignisWhereUniqueInput>>;
  set?: InputMaybe<Array<EreignisWhereUniqueInput>>;
};

export type EreignisTyp = {
  __typename?: 'EreignisTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EreignisTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EreignisTypManyRelationFilter = {
  every?: InputMaybe<EreignisTypWhereInput>;
  none?: InputMaybe<EreignisTypWhereInput>;
  some?: InputMaybe<EreignisTypWhereInput>;
};

export type EreignisTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type EreignisTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<EreignisTypWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisTypCreateInput>>;
};

export type EreignisTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<EreignisTypWhereUniqueInput>>;
  create?: InputMaybe<Array<EreignisTypCreateInput>>;
  disconnect?: InputMaybe<Array<EreignisTypWhereUniqueInput>>;
  set?: InputMaybe<Array<EreignisTypWhereUniqueInput>>;
};

export type EreignisTypUpdateArgs = {
  data: EreignisTypUpdateInput;
  where: EreignisTypWhereUniqueInput;
};

export type EreignisTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EreignisTypWhereInput = {
  AND?: InputMaybe<Array<EreignisTypWhereInput>>;
  NOT?: InputMaybe<Array<EreignisTypWhereInput>>;
  OR?: InputMaybe<Array<EreignisTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type EreignisTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EreignisUpdateArgs = {
  data: EreignisUpdateInput;
  where: EreignisWhereUniqueInput;
};

export type EreignisUpdateInput = {
  characters?: InputMaybe<PersonRelateToManyForUpdateInput>;
  contains?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  descriptionAuthor?: InputMaybe<PersonRelateToManyForUpdateInput>;
  eigenschaften?: InputMaybe<EreignisEigenschaftRelateToManyForUpdateInput>;
  groupsOnEvent?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  images?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  locationOnEvent?: InputMaybe<OrtRelateToManyForUpdateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectsOnEvent?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  otherTitles?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForUpdateInput>;
  personsOnEvent?: InputMaybe<PersonRelateToManyForUpdateInput>;
  place?: InputMaybe<OrtRelateToOneForUpdateInput>;
  similarFrom?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  similarTo?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typen?: InputMaybe<EreignisTypRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForUpdateInput>;
};

export type EreignisWhereInput = {
  AND?: InputMaybe<Array<EreignisWhereInput>>;
  NOT?: InputMaybe<Array<EreignisWhereInput>>;
  OR?: InputMaybe<Array<EreignisWhereInput>>;
  characters?: InputMaybe<PersonManyRelationFilter>;
  contains?: InputMaybe<EreignisManyRelationFilter>;
  descriptionAuthor?: InputMaybe<PersonManyRelationFilter>;
  eigenschaften?: InputMaybe<EreignisEigenschaftManyRelationFilter>;
  groupsOnEvent?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  images?: InputMaybe<ObjektManyRelationFilter>;
  locationOnEvent?: InputMaybe<OrtManyRelationFilter>;
  objectsOnEvent?: InputMaybe<ObjektManyRelationFilter>;
  otherTitles?: InputMaybe<StringFilter>;
  partOf?: InputMaybe<EreignisManyRelationFilter>;
  periodOfOrigin?: InputMaybe<EntstehungszeitWhereInput>;
  personsOnEvent?: InputMaybe<PersonManyRelationFilter>;
  place?: InputMaybe<OrtWhereInput>;
  similarFrom?: InputMaybe<EreignisManyRelationFilter>;
  similarTo?: InputMaybe<EreignisManyRelationFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  typen?: InputMaybe<EreignisTypManyRelationFilter>;
  zustaende?: InputMaybe<StatusManyRelationFilter>;
};

export type EreignisWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Ereignis_Description_Document = {
  __typename?: 'Ereignis_description_Document';
  document: Scalars['JSON']['output'];
};


export type Ereignis_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ereignis_Notes_Document = {
  __typename?: 'Ereignis_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Ereignis_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ereignis_Sources_Document = {
  __typename?: 'Ereignis_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Ereignis_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ereignis_Weblinks_Document = {
  __typename?: 'Ereignis_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Ereignis_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Foto = {
  __typename?: 'Foto';
  bild?: Maybe<ImageFieldOutput>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type FotoObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type FotoObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type FotoCreateInput = {
  bild?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FotoManyRelationFilter = {
  every?: InputMaybe<FotoWhereInput>;
  none?: InputMaybe<FotoWhereInput>;
  some?: InputMaybe<FotoWhereInput>;
};

export type FotoOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type FotoRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<FotoWhereUniqueInput>>;
  create?: InputMaybe<Array<FotoCreateInput>>;
};

export type FotoRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<FotoWhereUniqueInput>>;
  create?: InputMaybe<Array<FotoCreateInput>>;
  disconnect?: InputMaybe<Array<FotoWhereUniqueInput>>;
  set?: InputMaybe<Array<FotoWhereUniqueInput>>;
};

export type FotoUpdateArgs = {
  data: FotoUpdateInput;
  where: FotoWhereUniqueInput;
};

export type FotoUpdateInput = {
  bild?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FotoWhereInput = {
  AND?: InputMaybe<Array<FotoWhereInput>>;
  NOT?: InputMaybe<Array<FotoWhereInput>>;
  OR?: InputMaybe<Array<FotoWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
  title?: InputMaybe<StringFilter>;
};

export type FotoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Gebiet = {
  __typename?: 'Gebiet';
  description?: Maybe<Gebiet_Description_Document>;
  enthaelt?: Maybe<Array<Gebiet>>;
  enthaeltCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Gebiet_Notes_Document>;
  orte?: Maybe<Array<Ort>>;
  orteCount?: Maybe<Scalars['Int']['output']>;
  otherNames?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Gebiet_Sources_Document>;
  teilVon?: Maybe<Gebiet>;
  typen?: Maybe<Array<GebietsTyp>>;
  typenCount?: Maybe<Scalars['Int']['output']>;
  weblinks?: Maybe<Gebiet_Weblinks_Document>;
};


export type GebietEnthaeltArgs = {
  cursor?: InputMaybe<GebietWhereUniqueInput>;
  orderBy?: Array<GebietOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GebietWhereInput;
};


export type GebietEnthaeltCountArgs = {
  where?: GebietWhereInput;
};


export type GebietOrteArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type GebietOrteCountArgs = {
  where?: OrtWhereInput;
};


export type GebietTypenArgs = {
  cursor?: InputMaybe<GebietsTypWhereUniqueInput>;
  orderBy?: Array<GebietsTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GebietsTypWhereInput;
};


export type GebietTypenCountArgs = {
  where?: GebietsTypWhereInput;
};

export type GebietCreateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  enthaelt?: InputMaybe<GebietRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  orte?: InputMaybe<OrtRelateToManyForCreateInput>;
  otherNames?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  teilVon?: InputMaybe<GebietRelateToOneForCreateInput>;
  typen?: InputMaybe<GebietsTypRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type GebietManyRelationFilter = {
  every?: InputMaybe<GebietWhereInput>;
  none?: InputMaybe<GebietWhereInput>;
  some?: InputMaybe<GebietWhereInput>;
};

export type GebietOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  otherNames?: InputMaybe<OrderDirection>;
};

export type GebietRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GebietWhereUniqueInput>>;
  create?: InputMaybe<Array<GebietCreateInput>>;
};

export type GebietRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GebietWhereUniqueInput>>;
  create?: InputMaybe<Array<GebietCreateInput>>;
  disconnect?: InputMaybe<Array<GebietWhereUniqueInput>>;
  set?: InputMaybe<Array<GebietWhereUniqueInput>>;
};

export type GebietRelateToOneForCreateInput = {
  connect?: InputMaybe<GebietWhereUniqueInput>;
  create?: InputMaybe<GebietCreateInput>;
};

export type GebietRelateToOneForUpdateInput = {
  connect?: InputMaybe<GebietWhereUniqueInput>;
  create?: InputMaybe<GebietCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GebietUpdateArgs = {
  data: GebietUpdateInput;
  where: GebietWhereUniqueInput;
};

export type GebietUpdateInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  enthaelt?: InputMaybe<GebietRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  orte?: InputMaybe<OrtRelateToManyForUpdateInput>;
  otherNames?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  teilVon?: InputMaybe<GebietRelateToOneForUpdateInput>;
  typen?: InputMaybe<GebietsTypRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type GebietWhereInput = {
  AND?: InputMaybe<Array<GebietWhereInput>>;
  NOT?: InputMaybe<Array<GebietWhereInput>>;
  OR?: InputMaybe<Array<GebietWhereInput>>;
  enthaelt?: InputMaybe<GebietManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  orte?: InputMaybe<OrtManyRelationFilter>;
  otherNames?: InputMaybe<StringFilter>;
  teilVon?: InputMaybe<GebietWhereInput>;
  typen?: InputMaybe<GebietsTypManyRelationFilter>;
};

export type GebietWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Gebiet_Description_Document = {
  __typename?: 'Gebiet_description_Document';
  document: Scalars['JSON']['output'];
};


export type Gebiet_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gebiet_Notes_Document = {
  __typename?: 'Gebiet_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Gebiet_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gebiet_Sources_Document = {
  __typename?: 'Gebiet_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Gebiet_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gebiet_Weblinks_Document = {
  __typename?: 'Gebiet_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Gebiet_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type GebietsTyp = {
  __typename?: 'GebietsTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GebietsTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GebietsTypManyRelationFilter = {
  every?: InputMaybe<GebietsTypWhereInput>;
  none?: InputMaybe<GebietsTypWhereInput>;
  some?: InputMaybe<GebietsTypWhereInput>;
};

export type GebietsTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type GebietsTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GebietsTypWhereUniqueInput>>;
  create?: InputMaybe<Array<GebietsTypCreateInput>>;
};

export type GebietsTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GebietsTypWhereUniqueInput>>;
  create?: InputMaybe<Array<GebietsTypCreateInput>>;
  disconnect?: InputMaybe<Array<GebietsTypWhereUniqueInput>>;
  set?: InputMaybe<Array<GebietsTypWhereUniqueInput>>;
};

export type GebietsTypUpdateArgs = {
  data: GebietsTypUpdateInput;
  where: GebietsTypWhereUniqueInput;
};

export type GebietsTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GebietsTypWhereInput = {
  AND?: InputMaybe<Array<GebietsTypWhereInput>>;
  NOT?: InputMaybe<Array<GebietsTypWhereInput>>;
  OR?: InputMaybe<Array<GebietsTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GebietsTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Gruppe = {
  __typename?: 'Gruppe';
  bezeichnung?: Maybe<Scalars['String']['output']>;
  characters?: Maybe<Array<Person>>;
  charactersCount?: Maybe<Scalars['Int']['output']>;
  contains?: Maybe<Array<Gruppe>>;
  containsCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Gruppe_Description_Document>;
  displayName?: Maybe<Scalars['String']['output']>;
  eigenschaften?: Maybe<Array<GruppenEigenschaft>>;
  eigenschaftenCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Objekt>>;
  imagesCount?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Gruppe_Notes_Document>;
  objectAuthor?: Maybe<Array<Objekt>>;
  objectAuthorCount?: Maybe<Scalars['Int']['output']>;
  objectEditorGroup?: Maybe<Array<Objekt>>;
  objectEditorGroupCount?: Maybe<Scalars['Int']['output']>;
  objectOnWork?: Maybe<Array<Objekt>>;
  objectOnWorkCount?: Maybe<Scalars['Int']['output']>;
  onEvents?: Maybe<Array<Ereignis>>;
  onEventsCount?: Maybe<Scalars['Int']['output']>;
  otherTitles?: Maybe<Gruppe_OtherTitles_Document>;
  owner?: Maybe<Array<Eigentum>>;
  ownerCount?: Maybe<Scalars['Int']['output']>;
  partOf?: Maybe<Array<Gruppe>>;
  partOfCount?: Maybe<Scalars['Int']['output']>;
  periodOfOrigin?: Maybe<Entstehungszeit>;
  places?: Maybe<Array<Ort>>;
  placesCount?: Maybe<Scalars['Int']['output']>;
  typen?: Maybe<Array<GruppenTyp>>;
  typenCount?: Maybe<Scalars['Int']['output']>;
  weblinks?: Maybe<Gruppe_Weblinks_Document>;
  zustaende?: Maybe<Array<Status>>;
  zustaendeCount?: Maybe<Scalars['Int']['output']>;
};


export type GruppeCharactersArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type GruppeCharactersCountArgs = {
  where?: PersonWhereInput;
};


export type GruppeContainsArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type GruppeContainsCountArgs = {
  where?: GruppeWhereInput;
};


export type GruppeEigenschaftenArgs = {
  cursor?: InputMaybe<GruppenEigenschaftWhereUniqueInput>;
  orderBy?: Array<GruppenEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppenEigenschaftWhereInput;
};


export type GruppeEigenschaftenCountArgs = {
  where?: GruppenEigenschaftWhereInput;
};


export type GruppeImagesArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type GruppeImagesCountArgs = {
  where?: ObjektWhereInput;
};


export type GruppeObjectAuthorArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type GruppeObjectAuthorCountArgs = {
  where?: ObjektWhereInput;
};


export type GruppeObjectEditorGroupArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type GruppeObjectEditorGroupCountArgs = {
  where?: ObjektWhereInput;
};


export type GruppeObjectOnWorkArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type GruppeObjectOnWorkCountArgs = {
  where?: ObjektWhereInput;
};


export type GruppeOnEventsArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type GruppeOnEventsCountArgs = {
  where?: EreignisWhereInput;
};


export type GruppeOwnerArgs = {
  cursor?: InputMaybe<EigentumWhereUniqueInput>;
  orderBy?: Array<EigentumOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EigentumWhereInput;
};


export type GruppeOwnerCountArgs = {
  where?: EigentumWhereInput;
};


export type GruppePartOfArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type GruppePartOfCountArgs = {
  where?: GruppeWhereInput;
};


export type GruppePlacesArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type GruppePlacesCountArgs = {
  where?: OrtWhereInput;
};


export type GruppeTypenArgs = {
  cursor?: InputMaybe<GruppenTypWhereUniqueInput>;
  orderBy?: Array<GruppenTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppenTypWhereInput;
};


export type GruppeTypenCountArgs = {
  where?: GruppenTypWhereInput;
};


export type GruppeZustaendeArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type GruppeZustaendeCountArgs = {
  where?: StatusWhereInput;
};

export type GruppeCreateInput = {
  bezeichnung?: InputMaybe<Scalars['String']['input']>;
  characters?: InputMaybe<PersonRelateToManyForCreateInput>;
  contains?: InputMaybe<GruppeRelateToManyForCreateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<GruppenEigenschaftRelateToManyForCreateInput>;
  images?: InputMaybe<ObjektRelateToManyForCreateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectAuthor?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectEditorGroup?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectOnWork?: InputMaybe<ObjektRelateToManyForCreateInput>;
  onEvents?: InputMaybe<EreignisRelateToManyForCreateInput>;
  otherTitles?: InputMaybe<Scalars['JSON']['input']>;
  owner?: InputMaybe<EigentumRelateToManyForCreateInput>;
  partOf?: InputMaybe<GruppeRelateToManyForCreateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForCreateInput>;
  places?: InputMaybe<OrtRelateToManyForCreateInput>;
  typen?: InputMaybe<GruppenTypRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForCreateInput>;
};

export type GruppeManyRelationFilter = {
  every?: InputMaybe<GruppeWhereInput>;
  none?: InputMaybe<GruppeWhereInput>;
  some?: InputMaybe<GruppeWhereInput>;
};

export type GruppeOrderByInput = {
  bezeichnung?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type GruppeRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GruppeWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppeCreateInput>>;
};

export type GruppeRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GruppeWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppeCreateInput>>;
  disconnect?: InputMaybe<Array<GruppeWhereUniqueInput>>;
  set?: InputMaybe<Array<GruppeWhereUniqueInput>>;
};

export type GruppeUpdateArgs = {
  data: GruppeUpdateInput;
  where: GruppeWhereUniqueInput;
};

export type GruppeUpdateInput = {
  bezeichnung?: InputMaybe<Scalars['String']['input']>;
  characters?: InputMaybe<PersonRelateToManyForUpdateInput>;
  contains?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<GruppenEigenschaftRelateToManyForUpdateInput>;
  images?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectAuthor?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectEditorGroup?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectOnWork?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  onEvents?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  otherTitles?: InputMaybe<Scalars['JSON']['input']>;
  owner?: InputMaybe<EigentumRelateToManyForUpdateInput>;
  partOf?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForUpdateInput>;
  places?: InputMaybe<OrtRelateToManyForUpdateInput>;
  typen?: InputMaybe<GruppenTypRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForUpdateInput>;
};

export type GruppeWhereInput = {
  AND?: InputMaybe<Array<GruppeWhereInput>>;
  NOT?: InputMaybe<Array<GruppeWhereInput>>;
  OR?: InputMaybe<Array<GruppeWhereInput>>;
  bezeichnung?: InputMaybe<StringFilter>;
  characters?: InputMaybe<PersonManyRelationFilter>;
  contains?: InputMaybe<GruppeManyRelationFilter>;
  eigenschaften?: InputMaybe<GruppenEigenschaftManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  images?: InputMaybe<ObjektManyRelationFilter>;
  objectAuthor?: InputMaybe<ObjektManyRelationFilter>;
  objectEditorGroup?: InputMaybe<ObjektManyRelationFilter>;
  objectOnWork?: InputMaybe<ObjektManyRelationFilter>;
  onEvents?: InputMaybe<EreignisManyRelationFilter>;
  owner?: InputMaybe<EigentumManyRelationFilter>;
  partOf?: InputMaybe<GruppeManyRelationFilter>;
  periodOfOrigin?: InputMaybe<EntstehungszeitWhereInput>;
  places?: InputMaybe<OrtManyRelationFilter>;
  typen?: InputMaybe<GruppenTypManyRelationFilter>;
  zustaende?: InputMaybe<StatusManyRelationFilter>;
};

export type GruppeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Gruppe_Description_Document = {
  __typename?: 'Gruppe_description_Document';
  document: Scalars['JSON']['output'];
};


export type Gruppe_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gruppe_Notes_Document = {
  __typename?: 'Gruppe_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Gruppe_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gruppe_OtherTitles_Document = {
  __typename?: 'Gruppe_otherTitles_Document';
  document: Scalars['JSON']['output'];
};


export type Gruppe_OtherTitles_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Gruppe_Weblinks_Document = {
  __typename?: 'Gruppe_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Gruppe_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type GruppenEigenschaft = {
  __typename?: 'GruppenEigenschaft';
  gruppen?: Maybe<Array<Gruppe>>;
  gruppenCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};


export type GruppenEigenschaftGruppenArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type GruppenEigenschaftGruppenCountArgs = {
  where?: GruppeWhereInput;
};

export type GruppenEigenschaftCreateInput = {
  gruppen?: InputMaybe<GruppeRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GruppenEigenschaftManyRelationFilter = {
  every?: InputMaybe<GruppenEigenschaftWhereInput>;
  none?: InputMaybe<GruppenEigenschaftWhereInput>;
  some?: InputMaybe<GruppenEigenschaftWhereInput>;
};

export type GruppenEigenschaftOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type GruppenEigenschaftRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GruppenEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppenEigenschaftCreateInput>>;
};

export type GruppenEigenschaftRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GruppenEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppenEigenschaftCreateInput>>;
  disconnect?: InputMaybe<Array<GruppenEigenschaftWhereUniqueInput>>;
  set?: InputMaybe<Array<GruppenEigenschaftWhereUniqueInput>>;
};

export type GruppenEigenschaftUpdateArgs = {
  data: GruppenEigenschaftUpdateInput;
  where: GruppenEigenschaftWhereUniqueInput;
};

export type GruppenEigenschaftUpdateInput = {
  gruppen?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GruppenEigenschaftWhereInput = {
  AND?: InputMaybe<Array<GruppenEigenschaftWhereInput>>;
  NOT?: InputMaybe<Array<GruppenEigenschaftWhereInput>>;
  OR?: InputMaybe<Array<GruppenEigenschaftWhereInput>>;
  gruppen?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GruppenEigenschaftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GruppenTyp = {
  __typename?: 'GruppenTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GruppenTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GruppenTypManyRelationFilter = {
  every?: InputMaybe<GruppenTypWhereInput>;
  none?: InputMaybe<GruppenTypWhereInput>;
  some?: InputMaybe<GruppenTypWhereInput>;
};

export type GruppenTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type GruppenTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<GruppenTypWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppenTypCreateInput>>;
};

export type GruppenTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<GruppenTypWhereUniqueInput>>;
  create?: InputMaybe<Array<GruppenTypCreateInput>>;
  disconnect?: InputMaybe<Array<GruppenTypWhereUniqueInput>>;
  set?: InputMaybe<Array<GruppenTypWhereUniqueInput>>;
};

export type GruppenTypUpdateArgs = {
  data: GruppenTypUpdateInput;
  where: GruppenTypWhereUniqueInput;
};

export type GruppenTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GruppenTypWhereInput = {
  AND?: InputMaybe<Array<GruppenTypWhereInput>>;
  NOT?: InputMaybe<Array<GruppenTypWhereInput>>;
  OR?: InputMaybe<Array<GruppenTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GruppenTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Hochzeit = {
  __typename?: 'Hochzeit';
  datum?: Maybe<Scalars['CalendarDay']['output']>;
  description?: Maybe<Hochzeit_Description_Document>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Ort>;
  notes?: Maybe<Hochzeit_Notes_Document>;
  sources?: Maybe<Hochzeit_Sources_Document>;
  spouses?: Maybe<Array<Person>>;
  spousesCount?: Maybe<Scalars['Int']['output']>;
  spousesTaufbuch?: Maybe<Array<Person>>;
  spousesTaufbuchCount?: Maybe<Scalars['Int']['output']>;
  weblinks?: Maybe<Hochzeit_Weblinks_Document>;
};


export type HochzeitSpousesArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type HochzeitSpousesCountArgs = {
  where?: PersonWhereInput;
};


export type HochzeitSpousesTaufbuchArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type HochzeitSpousesTaufbuchCountArgs = {
  where?: PersonWhereInput;
};

export type HochzeitCreateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<OrtRelateToOneForCreateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  spouses?: InputMaybe<PersonRelateToManyForCreateInput>;
  spousesTaufbuch?: InputMaybe<PersonRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type HochzeitManyRelationFilter = {
  every?: InputMaybe<HochzeitWhereInput>;
  none?: InputMaybe<HochzeitWhereInput>;
  some?: InputMaybe<HochzeitWhereInput>;
};

export type HochzeitOrderByInput = {
  datum?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
};

export type HochzeitRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<HochzeitWhereUniqueInput>>;
  create?: InputMaybe<Array<HochzeitCreateInput>>;
};

export type HochzeitRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<HochzeitWhereUniqueInput>>;
  create?: InputMaybe<Array<HochzeitCreateInput>>;
  disconnect?: InputMaybe<Array<HochzeitWhereUniqueInput>>;
  set?: InputMaybe<Array<HochzeitWhereUniqueInput>>;
};

export type HochzeitUpdateArgs = {
  data: HochzeitUpdateInput;
  where: HochzeitWhereUniqueInput;
};

export type HochzeitUpdateInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  location?: InputMaybe<OrtRelateToOneForUpdateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  spouses?: InputMaybe<PersonRelateToManyForUpdateInput>;
  spousesTaufbuch?: InputMaybe<PersonRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
};

export type HochzeitWhereInput = {
  AND?: InputMaybe<Array<HochzeitWhereInput>>;
  NOT?: InputMaybe<Array<HochzeitWhereInput>>;
  OR?: InputMaybe<Array<HochzeitWhereInput>>;
  datum?: InputMaybe<CalendarDayNullableFilter>;
  id?: InputMaybe<IdFilter>;
  location?: InputMaybe<OrtWhereInput>;
  spouses?: InputMaybe<PersonManyRelationFilter>;
  spousesTaufbuch?: InputMaybe<PersonManyRelationFilter>;
};

export type HochzeitWhereUniqueInput = {
  datum?: InputMaybe<Scalars['CalendarDay']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Hochzeit_Description_Document = {
  __typename?: 'Hochzeit_description_Document';
  document: Scalars['JSON']['output'];
};


export type Hochzeit_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Hochzeit_Notes_Document = {
  __typename?: 'Hochzeit_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Hochzeit_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Hochzeit_Sources_Document = {
  __typename?: 'Hochzeit_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Hochzeit_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Hochzeit_Weblinks_Document = {
  __typename?: 'Hochzeit_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Hochzeit_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ImageExtension {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type ImageFieldInput = {
  upload: Scalars['Upload']['input'];
};

export type ImageFieldOutput = {
  __typename?: 'ImageFieldOutput';
  extension: ImageExtension;
  filesize: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String']['input'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String']['output'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  isFilterable: Scalars['Boolean']['output'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean']['output'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String']['output'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String']['output'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int']['output'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean']['output'];
  hideDelete: Scalars['Boolean']['output'];
  initialColumns: Array<Scalars['String']['output']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  itemQueryName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelField: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  pageSize: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String']['output'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type Kirchenbuch = {
  __typename?: 'Kirchenbuch';
  bilder?: Maybe<Array<KirchenbuchBild>>;
  bilderCount?: Maybe<Scalars['Int']['output']>;
  gemeinde?: Maybe<Gebiet>;
  id: Scalars['ID']['output'];
  kennung?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Kirchenbuch_Notes_Document>;
  personenSterbebuch?: Maybe<Array<Person>>;
  personenSterbebuchCount?: Maybe<Scalars['Int']['output']>;
  personenTaufbuch?: Maybe<Array<Person>>;
  personenTaufbuchCount?: Maybe<Scalars['Int']['output']>;
  typ?: Maybe<Array<KirchenbuchTyp>>;
  typCount?: Maybe<Scalars['Int']['output']>;
};


export type KirchenbuchBilderArgs = {
  cursor?: InputMaybe<KirchenbuchBildWhereUniqueInput>;
  orderBy?: Array<KirchenbuchBildOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchBildWhereInput;
};


export type KirchenbuchBilderCountArgs = {
  where?: KirchenbuchBildWhereInput;
};


export type KirchenbuchPersonenSterbebuchArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type KirchenbuchPersonenSterbebuchCountArgs = {
  where?: PersonWhereInput;
};


export type KirchenbuchPersonenTaufbuchArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type KirchenbuchPersonenTaufbuchCountArgs = {
  where?: PersonWhereInput;
};


export type KirchenbuchTypArgs = {
  cursor?: InputMaybe<KirchenbuchTypWhereUniqueInput>;
  orderBy?: Array<KirchenbuchTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchTypWhereInput;
};


export type KirchenbuchTypCountArgs = {
  where?: KirchenbuchTypWhereInput;
};

export type KirchenbuchBild = {
  __typename?: 'KirchenbuchBild';
  bild?: Maybe<ImageFieldOutput>;
  id: Scalars['ID']['output'];
  kirchenbuch?: Maybe<Kirchenbuch>;
  name?: Maybe<Scalars['String']['output']>;
  personenSterbebuchImg?: Maybe<Array<Person>>;
  personenSterbebuchImgCount?: Maybe<Scalars['Int']['output']>;
  personenTaufbuchImg?: Maybe<Array<Person>>;
  personenTaufbuchImgCount?: Maybe<Scalars['Int']['output']>;
};


export type KirchenbuchBildPersonenSterbebuchImgArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type KirchenbuchBildPersonenSterbebuchImgCountArgs = {
  where?: PersonWhereInput;
};


export type KirchenbuchBildPersonenTaufbuchImgArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type KirchenbuchBildPersonenTaufbuchImgCountArgs = {
  where?: PersonWhereInput;
};

export type KirchenbuchBildCreateInput = {
  bild?: InputMaybe<ImageFieldInput>;
  kirchenbuch?: InputMaybe<KirchenbuchRelateToOneForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  personenSterbebuchImg?: InputMaybe<PersonRelateToManyForCreateInput>;
  personenTaufbuchImg?: InputMaybe<PersonRelateToManyForCreateInput>;
};

export type KirchenbuchBildManyRelationFilter = {
  every?: InputMaybe<KirchenbuchBildWhereInput>;
  none?: InputMaybe<KirchenbuchBildWhereInput>;
  some?: InputMaybe<KirchenbuchBildWhereInput>;
};

export type KirchenbuchBildOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type KirchenbuchBildRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<KirchenbuchBildWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchBildCreateInput>>;
};

export type KirchenbuchBildRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<KirchenbuchBildWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchBildCreateInput>>;
  disconnect?: InputMaybe<Array<KirchenbuchBildWhereUniqueInput>>;
  set?: InputMaybe<Array<KirchenbuchBildWhereUniqueInput>>;
};

export type KirchenbuchBildRelateToOneForCreateInput = {
  connect?: InputMaybe<KirchenbuchBildWhereUniqueInput>;
  create?: InputMaybe<KirchenbuchBildCreateInput>;
};

export type KirchenbuchBildRelateToOneForUpdateInput = {
  connect?: InputMaybe<KirchenbuchBildWhereUniqueInput>;
  create?: InputMaybe<KirchenbuchBildCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KirchenbuchBildUpdateArgs = {
  data: KirchenbuchBildUpdateInput;
  where: KirchenbuchBildWhereUniqueInput;
};

export type KirchenbuchBildUpdateInput = {
  bild?: InputMaybe<ImageFieldInput>;
  kirchenbuch?: InputMaybe<KirchenbuchRelateToOneForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  personenSterbebuchImg?: InputMaybe<PersonRelateToManyForUpdateInput>;
  personenTaufbuchImg?: InputMaybe<PersonRelateToManyForUpdateInput>;
};

export type KirchenbuchBildWhereInput = {
  AND?: InputMaybe<Array<KirchenbuchBildWhereInput>>;
  NOT?: InputMaybe<Array<KirchenbuchBildWhereInput>>;
  OR?: InputMaybe<Array<KirchenbuchBildWhereInput>>;
  id?: InputMaybe<IdFilter>;
  kirchenbuch?: InputMaybe<KirchenbuchWhereInput>;
  name?: InputMaybe<StringFilter>;
  personenSterbebuchImg?: InputMaybe<PersonManyRelationFilter>;
  personenTaufbuchImg?: InputMaybe<PersonManyRelationFilter>;
};

export type KirchenbuchBildWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KirchenbuchCreateInput = {
  bilder?: InputMaybe<KirchenbuchBildRelateToManyForCreateInput>;
  gemeinde?: InputMaybe<GebietRelateToOneForCreateInput>;
  kennung?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  personenSterbebuch?: InputMaybe<PersonRelateToManyForCreateInput>;
  personenTaufbuch?: InputMaybe<PersonRelateToManyForCreateInput>;
  typ?: InputMaybe<KirchenbuchTypRelateToManyForCreateInput>;
};

export type KirchenbuchManyRelationFilter = {
  every?: InputMaybe<KirchenbuchWhereInput>;
  none?: InputMaybe<KirchenbuchWhereInput>;
  some?: InputMaybe<KirchenbuchWhereInput>;
};

export type KirchenbuchOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  kennung?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type KirchenbuchRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<KirchenbuchWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchCreateInput>>;
};

export type KirchenbuchRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<KirchenbuchWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchCreateInput>>;
  disconnect?: InputMaybe<Array<KirchenbuchWhereUniqueInput>>;
  set?: InputMaybe<Array<KirchenbuchWhereUniqueInput>>;
};

export type KirchenbuchRelateToOneForCreateInput = {
  connect?: InputMaybe<KirchenbuchWhereUniqueInput>;
  create?: InputMaybe<KirchenbuchCreateInput>;
};

export type KirchenbuchRelateToOneForUpdateInput = {
  connect?: InputMaybe<KirchenbuchWhereUniqueInput>;
  create?: InputMaybe<KirchenbuchCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KirchenbuchTyp = {
  __typename?: 'KirchenbuchTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type KirchenbuchTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KirchenbuchTypManyRelationFilter = {
  every?: InputMaybe<KirchenbuchTypWhereInput>;
  none?: InputMaybe<KirchenbuchTypWhereInput>;
  some?: InputMaybe<KirchenbuchTypWhereInput>;
};

export type KirchenbuchTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type KirchenbuchTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<KirchenbuchTypWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchTypCreateInput>>;
};

export type KirchenbuchTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<KirchenbuchTypWhereUniqueInput>>;
  create?: InputMaybe<Array<KirchenbuchTypCreateInput>>;
  disconnect?: InputMaybe<Array<KirchenbuchTypWhereUniqueInput>>;
  set?: InputMaybe<Array<KirchenbuchTypWhereUniqueInput>>;
};

export type KirchenbuchTypUpdateArgs = {
  data: KirchenbuchTypUpdateInput;
  where: KirchenbuchTypWhereUniqueInput;
};

export type KirchenbuchTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KirchenbuchTypWhereInput = {
  AND?: InputMaybe<Array<KirchenbuchTypWhereInput>>;
  NOT?: InputMaybe<Array<KirchenbuchTypWhereInput>>;
  OR?: InputMaybe<Array<KirchenbuchTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type KirchenbuchTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KirchenbuchUpdateArgs = {
  data: KirchenbuchUpdateInput;
  where: KirchenbuchWhereUniqueInput;
};

export type KirchenbuchUpdateInput = {
  bilder?: InputMaybe<KirchenbuchBildRelateToManyForUpdateInput>;
  gemeinde?: InputMaybe<GebietRelateToOneForUpdateInput>;
  kennung?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  personenSterbebuch?: InputMaybe<PersonRelateToManyForUpdateInput>;
  personenTaufbuch?: InputMaybe<PersonRelateToManyForUpdateInput>;
  typ?: InputMaybe<KirchenbuchTypRelateToManyForUpdateInput>;
};

export type KirchenbuchWhereInput = {
  AND?: InputMaybe<Array<KirchenbuchWhereInput>>;
  NOT?: InputMaybe<Array<KirchenbuchWhereInput>>;
  OR?: InputMaybe<Array<KirchenbuchWhereInput>>;
  bilder?: InputMaybe<KirchenbuchBildManyRelationFilter>;
  gemeinde?: InputMaybe<GebietWhereInput>;
  id?: InputMaybe<IdFilter>;
  kennung?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  personenSterbebuch?: InputMaybe<PersonManyRelationFilter>;
  personenTaufbuch?: InputMaybe<PersonManyRelationFilter>;
  typ?: InputMaybe<KirchenbuchTypManyRelationFilter>;
};

export type KirchenbuchWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kennung?: InputMaybe<Scalars['String']['input']>;
};

export type Kirchenbuch_Notes_Document = {
  __typename?: 'Kirchenbuch_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Kirchenbuch_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticateUserWithPassword?: Maybe<UserAuthenticationWithPasswordResult>;
  createBerufsTyp?: Maybe<BerufsTyp>;
  createBerufsTyps?: Maybe<Array<Maybe<BerufsTyp>>>;
  createCopyrightTyp?: Maybe<CopyrightTyp>;
  createCopyrightTyps?: Maybe<Array<Maybe<CopyrightTyp>>>;
  createEigentum?: Maybe<Eigentum>;
  createEigentums?: Maybe<Array<Maybe<Eigentum>>>;
  createEntstehungszeit?: Maybe<Entstehungszeit>;
  createEntstehungszeits?: Maybe<Array<Maybe<Entstehungszeit>>>;
  createEreignis?: Maybe<Ereignis>;
  createEreignisEigenschaft?: Maybe<EreignisEigenschaft>;
  createEreignisEigenschafts?: Maybe<Array<Maybe<EreignisEigenschaft>>>;
  createEreignisTyp?: Maybe<EreignisTyp>;
  createEreignisTyps?: Maybe<Array<Maybe<EreignisTyp>>>;
  createEreignisse?: Maybe<Array<Maybe<Ereignis>>>;
  createFoto?: Maybe<Foto>;
  createFotos?: Maybe<Array<Maybe<Foto>>>;
  createGebiet?: Maybe<Gebiet>;
  createGebiets?: Maybe<Array<Maybe<Gebiet>>>;
  createGebietsTyp?: Maybe<GebietsTyp>;
  createGebietsTyps?: Maybe<Array<Maybe<GebietsTyp>>>;
  createGruppe?: Maybe<Gruppe>;
  createGruppenEigenschaft?: Maybe<GruppenEigenschaft>;
  createGruppenEigenschafts?: Maybe<Array<Maybe<GruppenEigenschaft>>>;
  createGruppenTyp?: Maybe<GruppenTyp>;
  createGruppenTyps?: Maybe<Array<Maybe<GruppenTyp>>>;
  createGruppes?: Maybe<Array<Maybe<Gruppe>>>;
  createHochzeit?: Maybe<Hochzeit>;
  createHochzeits?: Maybe<Array<Maybe<Hochzeit>>>;
  createInitialUser: UserAuthenticationWithPasswordSuccess;
  createKirchenbuch?: Maybe<Kirchenbuch>;
  createKirchenbuchBild?: Maybe<KirchenbuchBild>;
  createKirchenbuchBilds?: Maybe<Array<Maybe<KirchenbuchBild>>>;
  createKirchenbuchTyp?: Maybe<KirchenbuchTyp>;
  createKirchenbuchTyps?: Maybe<Array<Maybe<KirchenbuchTyp>>>;
  createKirchenbuches?: Maybe<Array<Maybe<Kirchenbuch>>>;
  createObjekt?: Maybe<Objekt>;
  createObjektEigenschaftFoto?: Maybe<ObjektEigenschaftFoto>;
  createObjektEigenschaftFotos?: Maybe<Array<Maybe<ObjektEigenschaftFoto>>>;
  createObjektEigenschaftMaterial?: Maybe<ObjektEigenschaftMaterial>;
  createObjektEigenschaftMaterials?: Maybe<Array<Maybe<ObjektEigenschaftMaterial>>>;
  createObjektEigenschaftPublikation?: Maybe<ObjektEigenschaftPublikation>;
  createObjektEigenschaftPublikations?: Maybe<Array<Maybe<ObjektEigenschaftPublikation>>>;
  createObjektEigenschaftTechnik?: Maybe<ObjektEigenschaftTechnik>;
  createObjektEigenschaftTechniks?: Maybe<Array<Maybe<ObjektEigenschaftTechnik>>>;
  createObjektEigenschaftVolkskunde?: Maybe<ObjektEigenschaftVolkskunde>;
  createObjektEigenschaftVolkskundes?: Maybe<Array<Maybe<ObjektEigenschaftVolkskunde>>>;
  createObjektTyp?: Maybe<ObjektTyp>;
  createObjektTyps?: Maybe<Array<Maybe<ObjektTyp>>>;
  createObjekts?: Maybe<Array<Maybe<Objekt>>>;
  createOrt?: Maybe<Ort>;
  createOrtTyp?: Maybe<OrtTyp>;
  createOrtTyps?: Maybe<Array<Maybe<OrtTyp>>>;
  createOrts?: Maybe<Array<Maybe<Ort>>>;
  createOrtsEigenschaft?: Maybe<OrtsEigenschaft>;
  createOrtsEigenschafts?: Maybe<Array<Maybe<OrtsEigenschaft>>>;
  createPeople?: Maybe<Array<Maybe<Person>>>;
  createPerson?: Maybe<Person>;
  createPersonenEigenschaft?: Maybe<PersonenEigenschaft>;
  createPersonenEigenschafts?: Maybe<Array<Maybe<PersonenEigenschaft>>>;
  createStatus?: Maybe<Status>;
  createStatuses?: Maybe<Array<Maybe<Status>>>;
  createSterbebildEigenschaft?: Maybe<SterbebildEigenschaft>;
  createSterbebildEigenschafts?: Maybe<Array<Maybe<SterbebildEigenschaft>>>;
  createUser?: Maybe<User>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  createZeitspanne?: Maybe<Zeitspanne>;
  createZeitspannes?: Maybe<Array<Maybe<Zeitspanne>>>;
  deleteBerufsTyp?: Maybe<BerufsTyp>;
  deleteBerufsTyps?: Maybe<Array<Maybe<BerufsTyp>>>;
  deleteCopyrightTyp?: Maybe<CopyrightTyp>;
  deleteCopyrightTyps?: Maybe<Array<Maybe<CopyrightTyp>>>;
  deleteEigentum?: Maybe<Eigentum>;
  deleteEigentums?: Maybe<Array<Maybe<Eigentum>>>;
  deleteEntstehungszeit?: Maybe<Entstehungszeit>;
  deleteEntstehungszeits?: Maybe<Array<Maybe<Entstehungszeit>>>;
  deleteEreignis?: Maybe<Ereignis>;
  deleteEreignisEigenschaft?: Maybe<EreignisEigenschaft>;
  deleteEreignisEigenschafts?: Maybe<Array<Maybe<EreignisEigenschaft>>>;
  deleteEreignisTyp?: Maybe<EreignisTyp>;
  deleteEreignisTyps?: Maybe<Array<Maybe<EreignisTyp>>>;
  deleteEreignisse?: Maybe<Array<Maybe<Ereignis>>>;
  deleteFoto?: Maybe<Foto>;
  deleteFotos?: Maybe<Array<Maybe<Foto>>>;
  deleteGebiet?: Maybe<Gebiet>;
  deleteGebiets?: Maybe<Array<Maybe<Gebiet>>>;
  deleteGebietsTyp?: Maybe<GebietsTyp>;
  deleteGebietsTyps?: Maybe<Array<Maybe<GebietsTyp>>>;
  deleteGruppe?: Maybe<Gruppe>;
  deleteGruppenEigenschaft?: Maybe<GruppenEigenschaft>;
  deleteGruppenEigenschafts?: Maybe<Array<Maybe<GruppenEigenschaft>>>;
  deleteGruppenTyp?: Maybe<GruppenTyp>;
  deleteGruppenTyps?: Maybe<Array<Maybe<GruppenTyp>>>;
  deleteGruppes?: Maybe<Array<Maybe<Gruppe>>>;
  deleteHochzeit?: Maybe<Hochzeit>;
  deleteHochzeits?: Maybe<Array<Maybe<Hochzeit>>>;
  deleteKirchenbuch?: Maybe<Kirchenbuch>;
  deleteKirchenbuchBild?: Maybe<KirchenbuchBild>;
  deleteKirchenbuchBilds?: Maybe<Array<Maybe<KirchenbuchBild>>>;
  deleteKirchenbuchTyp?: Maybe<KirchenbuchTyp>;
  deleteKirchenbuchTyps?: Maybe<Array<Maybe<KirchenbuchTyp>>>;
  deleteKirchenbuches?: Maybe<Array<Maybe<Kirchenbuch>>>;
  deleteObjekt?: Maybe<Objekt>;
  deleteObjektEigenschaftFoto?: Maybe<ObjektEigenschaftFoto>;
  deleteObjektEigenschaftFotos?: Maybe<Array<Maybe<ObjektEigenschaftFoto>>>;
  deleteObjektEigenschaftMaterial?: Maybe<ObjektEigenschaftMaterial>;
  deleteObjektEigenschaftMaterials?: Maybe<Array<Maybe<ObjektEigenschaftMaterial>>>;
  deleteObjektEigenschaftPublikation?: Maybe<ObjektEigenschaftPublikation>;
  deleteObjektEigenschaftPublikations?: Maybe<Array<Maybe<ObjektEigenschaftPublikation>>>;
  deleteObjektEigenschaftTechnik?: Maybe<ObjektEigenschaftTechnik>;
  deleteObjektEigenschaftTechniks?: Maybe<Array<Maybe<ObjektEigenschaftTechnik>>>;
  deleteObjektEigenschaftVolkskunde?: Maybe<ObjektEigenschaftVolkskunde>;
  deleteObjektEigenschaftVolkskundes?: Maybe<Array<Maybe<ObjektEigenschaftVolkskunde>>>;
  deleteObjektTyp?: Maybe<ObjektTyp>;
  deleteObjektTyps?: Maybe<Array<Maybe<ObjektTyp>>>;
  deleteObjekts?: Maybe<Array<Maybe<Objekt>>>;
  deleteOrt?: Maybe<Ort>;
  deleteOrtTyp?: Maybe<OrtTyp>;
  deleteOrtTyps?: Maybe<Array<Maybe<OrtTyp>>>;
  deleteOrts?: Maybe<Array<Maybe<Ort>>>;
  deleteOrtsEigenschaft?: Maybe<OrtsEigenschaft>;
  deleteOrtsEigenschafts?: Maybe<Array<Maybe<OrtsEigenschaft>>>;
  deletePeople?: Maybe<Array<Maybe<Person>>>;
  deletePerson?: Maybe<Person>;
  deletePersonenEigenschaft?: Maybe<PersonenEigenschaft>;
  deletePersonenEigenschafts?: Maybe<Array<Maybe<PersonenEigenschaft>>>;
  deleteStatus?: Maybe<Status>;
  deleteStatuses?: Maybe<Array<Maybe<Status>>>;
  deleteSterbebildEigenschaft?: Maybe<SterbebildEigenschaft>;
  deleteSterbebildEigenschafts?: Maybe<Array<Maybe<SterbebildEigenschaft>>>;
  deleteUser?: Maybe<User>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  deleteZeitspanne?: Maybe<Zeitspanne>;
  deleteZeitspannes?: Maybe<Array<Maybe<Zeitspanne>>>;
  endSession: Scalars['Boolean']['output'];
  updateBerufsTyp?: Maybe<BerufsTyp>;
  updateBerufsTyps?: Maybe<Array<Maybe<BerufsTyp>>>;
  updateCopyrightTyp?: Maybe<CopyrightTyp>;
  updateCopyrightTyps?: Maybe<Array<Maybe<CopyrightTyp>>>;
  updateEigentum?: Maybe<Eigentum>;
  updateEigentums?: Maybe<Array<Maybe<Eigentum>>>;
  updateEntstehungszeit?: Maybe<Entstehungszeit>;
  updateEntstehungszeits?: Maybe<Array<Maybe<Entstehungszeit>>>;
  updateEreignis?: Maybe<Ereignis>;
  updateEreignisEigenschaft?: Maybe<EreignisEigenschaft>;
  updateEreignisEigenschafts?: Maybe<Array<Maybe<EreignisEigenschaft>>>;
  updateEreignisTyp?: Maybe<EreignisTyp>;
  updateEreignisTyps?: Maybe<Array<Maybe<EreignisTyp>>>;
  updateEreignisse?: Maybe<Array<Maybe<Ereignis>>>;
  updateFoto?: Maybe<Foto>;
  updateFotos?: Maybe<Array<Maybe<Foto>>>;
  updateGebiet?: Maybe<Gebiet>;
  updateGebiets?: Maybe<Array<Maybe<Gebiet>>>;
  updateGebietsTyp?: Maybe<GebietsTyp>;
  updateGebietsTyps?: Maybe<Array<Maybe<GebietsTyp>>>;
  updateGruppe?: Maybe<Gruppe>;
  updateGruppenEigenschaft?: Maybe<GruppenEigenschaft>;
  updateGruppenEigenschafts?: Maybe<Array<Maybe<GruppenEigenschaft>>>;
  updateGruppenTyp?: Maybe<GruppenTyp>;
  updateGruppenTyps?: Maybe<Array<Maybe<GruppenTyp>>>;
  updateGruppes?: Maybe<Array<Maybe<Gruppe>>>;
  updateHochzeit?: Maybe<Hochzeit>;
  updateHochzeits?: Maybe<Array<Maybe<Hochzeit>>>;
  updateKirchenbuch?: Maybe<Kirchenbuch>;
  updateKirchenbuchBild?: Maybe<KirchenbuchBild>;
  updateKirchenbuchBilds?: Maybe<Array<Maybe<KirchenbuchBild>>>;
  updateKirchenbuchTyp?: Maybe<KirchenbuchTyp>;
  updateKirchenbuchTyps?: Maybe<Array<Maybe<KirchenbuchTyp>>>;
  updateKirchenbuches?: Maybe<Array<Maybe<Kirchenbuch>>>;
  updateObjekt?: Maybe<Objekt>;
  updateObjektEigenschaftFoto?: Maybe<ObjektEigenschaftFoto>;
  updateObjektEigenschaftFotos?: Maybe<Array<Maybe<ObjektEigenschaftFoto>>>;
  updateObjektEigenschaftMaterial?: Maybe<ObjektEigenschaftMaterial>;
  updateObjektEigenschaftMaterials?: Maybe<Array<Maybe<ObjektEigenschaftMaterial>>>;
  updateObjektEigenschaftPublikation?: Maybe<ObjektEigenschaftPublikation>;
  updateObjektEigenschaftPublikations?: Maybe<Array<Maybe<ObjektEigenschaftPublikation>>>;
  updateObjektEigenschaftTechnik?: Maybe<ObjektEigenschaftTechnik>;
  updateObjektEigenschaftTechniks?: Maybe<Array<Maybe<ObjektEigenschaftTechnik>>>;
  updateObjektEigenschaftVolkskunde?: Maybe<ObjektEigenschaftVolkskunde>;
  updateObjektEigenschaftVolkskundes?: Maybe<Array<Maybe<ObjektEigenschaftVolkskunde>>>;
  updateObjektTyp?: Maybe<ObjektTyp>;
  updateObjektTyps?: Maybe<Array<Maybe<ObjektTyp>>>;
  updateObjekts?: Maybe<Array<Maybe<Objekt>>>;
  updateOrt?: Maybe<Ort>;
  updateOrtTyp?: Maybe<OrtTyp>;
  updateOrtTyps?: Maybe<Array<Maybe<OrtTyp>>>;
  updateOrts?: Maybe<Array<Maybe<Ort>>>;
  updateOrtsEigenschaft?: Maybe<OrtsEigenschaft>;
  updateOrtsEigenschafts?: Maybe<Array<Maybe<OrtsEigenschaft>>>;
  updatePeople?: Maybe<Array<Maybe<Person>>>;
  updatePerson?: Maybe<Person>;
  updatePersonenEigenschaft?: Maybe<PersonenEigenschaft>;
  updatePersonenEigenschafts?: Maybe<Array<Maybe<PersonenEigenschaft>>>;
  updateStatus?: Maybe<Status>;
  updateStatuses?: Maybe<Array<Maybe<Status>>>;
  updateSterbebildEigenschaft?: Maybe<SterbebildEigenschaft>;
  updateSterbebildEigenschafts?: Maybe<Array<Maybe<SterbebildEigenschaft>>>;
  updateUser?: Maybe<User>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  updateZeitspanne?: Maybe<Zeitspanne>;
  updateZeitspannes?: Maybe<Array<Maybe<Zeitspanne>>>;
};


export type MutationAuthenticateUserWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreateBerufsTypArgs = {
  data: BerufsTypCreateInput;
};


export type MutationCreateBerufsTypsArgs = {
  data: Array<BerufsTypCreateInput>;
};


export type MutationCreateCopyrightTypArgs = {
  data: CopyrightTypCreateInput;
};


export type MutationCreateCopyrightTypsArgs = {
  data: Array<CopyrightTypCreateInput>;
};


export type MutationCreateEigentumArgs = {
  data: EigentumCreateInput;
};


export type MutationCreateEigentumsArgs = {
  data: Array<EigentumCreateInput>;
};


export type MutationCreateEntstehungszeitArgs = {
  data: EntstehungszeitCreateInput;
};


export type MutationCreateEntstehungszeitsArgs = {
  data: Array<EntstehungszeitCreateInput>;
};


export type MutationCreateEreignisArgs = {
  data: EreignisCreateInput;
};


export type MutationCreateEreignisEigenschaftArgs = {
  data: EreignisEigenschaftCreateInput;
};


export type MutationCreateEreignisEigenschaftsArgs = {
  data: Array<EreignisEigenschaftCreateInput>;
};


export type MutationCreateEreignisTypArgs = {
  data: EreignisTypCreateInput;
};


export type MutationCreateEreignisTypsArgs = {
  data: Array<EreignisTypCreateInput>;
};


export type MutationCreateEreignisseArgs = {
  data: Array<EreignisCreateInput>;
};


export type MutationCreateFotoArgs = {
  data: FotoCreateInput;
};


export type MutationCreateFotosArgs = {
  data: Array<FotoCreateInput>;
};


export type MutationCreateGebietArgs = {
  data: GebietCreateInput;
};


export type MutationCreateGebietsArgs = {
  data: Array<GebietCreateInput>;
};


export type MutationCreateGebietsTypArgs = {
  data: GebietsTypCreateInput;
};


export type MutationCreateGebietsTypsArgs = {
  data: Array<GebietsTypCreateInput>;
};


export type MutationCreateGruppeArgs = {
  data: GruppeCreateInput;
};


export type MutationCreateGruppenEigenschaftArgs = {
  data: GruppenEigenschaftCreateInput;
};


export type MutationCreateGruppenEigenschaftsArgs = {
  data: Array<GruppenEigenschaftCreateInput>;
};


export type MutationCreateGruppenTypArgs = {
  data: GruppenTypCreateInput;
};


export type MutationCreateGruppenTypsArgs = {
  data: Array<GruppenTypCreateInput>;
};


export type MutationCreateGruppesArgs = {
  data: Array<GruppeCreateInput>;
};


export type MutationCreateHochzeitArgs = {
  data: HochzeitCreateInput;
};


export type MutationCreateHochzeitsArgs = {
  data: Array<HochzeitCreateInput>;
};


export type MutationCreateInitialUserArgs = {
  data: CreateInitialUserInput;
};


export type MutationCreateKirchenbuchArgs = {
  data: KirchenbuchCreateInput;
};


export type MutationCreateKirchenbuchBildArgs = {
  data: KirchenbuchBildCreateInput;
};


export type MutationCreateKirchenbuchBildsArgs = {
  data: Array<KirchenbuchBildCreateInput>;
};


export type MutationCreateKirchenbuchTypArgs = {
  data: KirchenbuchTypCreateInput;
};


export type MutationCreateKirchenbuchTypsArgs = {
  data: Array<KirchenbuchTypCreateInput>;
};


export type MutationCreateKirchenbuchesArgs = {
  data: Array<KirchenbuchCreateInput>;
};


export type MutationCreateObjektArgs = {
  data: ObjektCreateInput;
};


export type MutationCreateObjektEigenschaftFotoArgs = {
  data: ObjektEigenschaftFotoCreateInput;
};


export type MutationCreateObjektEigenschaftFotosArgs = {
  data: Array<ObjektEigenschaftFotoCreateInput>;
};


export type MutationCreateObjektEigenschaftMaterialArgs = {
  data: ObjektEigenschaftMaterialCreateInput;
};


export type MutationCreateObjektEigenschaftMaterialsArgs = {
  data: Array<ObjektEigenschaftMaterialCreateInput>;
};


export type MutationCreateObjektEigenschaftPublikationArgs = {
  data: ObjektEigenschaftPublikationCreateInput;
};


export type MutationCreateObjektEigenschaftPublikationsArgs = {
  data: Array<ObjektEigenschaftPublikationCreateInput>;
};


export type MutationCreateObjektEigenschaftTechnikArgs = {
  data: ObjektEigenschaftTechnikCreateInput;
};


export type MutationCreateObjektEigenschaftTechniksArgs = {
  data: Array<ObjektEigenschaftTechnikCreateInput>;
};


export type MutationCreateObjektEigenschaftVolkskundeArgs = {
  data: ObjektEigenschaftVolkskundeCreateInput;
};


export type MutationCreateObjektEigenschaftVolkskundesArgs = {
  data: Array<ObjektEigenschaftVolkskundeCreateInput>;
};


export type MutationCreateObjektTypArgs = {
  data: ObjektTypCreateInput;
};


export type MutationCreateObjektTypsArgs = {
  data: Array<ObjektTypCreateInput>;
};


export type MutationCreateObjektsArgs = {
  data: Array<ObjektCreateInput>;
};


export type MutationCreateOrtArgs = {
  data: OrtCreateInput;
};


export type MutationCreateOrtTypArgs = {
  data: OrtTypCreateInput;
};


export type MutationCreateOrtTypsArgs = {
  data: Array<OrtTypCreateInput>;
};


export type MutationCreateOrtsArgs = {
  data: Array<OrtCreateInput>;
};


export type MutationCreateOrtsEigenschaftArgs = {
  data: OrtsEigenschaftCreateInput;
};


export type MutationCreateOrtsEigenschaftsArgs = {
  data: Array<OrtsEigenschaftCreateInput>;
};


export type MutationCreatePeopleArgs = {
  data: Array<PersonCreateInput>;
};


export type MutationCreatePersonArgs = {
  data: PersonCreateInput;
};


export type MutationCreatePersonenEigenschaftArgs = {
  data: PersonenEigenschaftCreateInput;
};


export type MutationCreatePersonenEigenschaftsArgs = {
  data: Array<PersonenEigenschaftCreateInput>;
};


export type MutationCreateStatusArgs = {
  data: StatusCreateInput;
};


export type MutationCreateStatusesArgs = {
  data: Array<StatusCreateInput>;
};


export type MutationCreateSterbebildEigenschaftArgs = {
  data: SterbebildEigenschaftCreateInput;
};


export type MutationCreateSterbebildEigenschaftsArgs = {
  data: Array<SterbebildEigenschaftCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationCreateZeitspanneArgs = {
  data: ZeitspanneCreateInput;
};


export type MutationCreateZeitspannesArgs = {
  data: Array<ZeitspanneCreateInput>;
};


export type MutationDeleteBerufsTypArgs = {
  where: BerufsTypWhereUniqueInput;
};


export type MutationDeleteBerufsTypsArgs = {
  where: Array<BerufsTypWhereUniqueInput>;
};


export type MutationDeleteCopyrightTypArgs = {
  where: CopyrightTypWhereUniqueInput;
};


export type MutationDeleteCopyrightTypsArgs = {
  where: Array<CopyrightTypWhereUniqueInput>;
};


export type MutationDeleteEigentumArgs = {
  where: EigentumWhereUniqueInput;
};


export type MutationDeleteEigentumsArgs = {
  where: Array<EigentumWhereUniqueInput>;
};


export type MutationDeleteEntstehungszeitArgs = {
  where: EntstehungszeitWhereUniqueInput;
};


export type MutationDeleteEntstehungszeitsArgs = {
  where: Array<EntstehungszeitWhereUniqueInput>;
};


export type MutationDeleteEreignisArgs = {
  where: EreignisWhereUniqueInput;
};


export type MutationDeleteEreignisEigenschaftArgs = {
  where: EreignisEigenschaftWhereUniqueInput;
};


export type MutationDeleteEreignisEigenschaftsArgs = {
  where: Array<EreignisEigenschaftWhereUniqueInput>;
};


export type MutationDeleteEreignisTypArgs = {
  where: EreignisTypWhereUniqueInput;
};


export type MutationDeleteEreignisTypsArgs = {
  where: Array<EreignisTypWhereUniqueInput>;
};


export type MutationDeleteEreignisseArgs = {
  where: Array<EreignisWhereUniqueInput>;
};


export type MutationDeleteFotoArgs = {
  where: FotoWhereUniqueInput;
};


export type MutationDeleteFotosArgs = {
  where: Array<FotoWhereUniqueInput>;
};


export type MutationDeleteGebietArgs = {
  where: GebietWhereUniqueInput;
};


export type MutationDeleteGebietsArgs = {
  where: Array<GebietWhereUniqueInput>;
};


export type MutationDeleteGebietsTypArgs = {
  where: GebietsTypWhereUniqueInput;
};


export type MutationDeleteGebietsTypsArgs = {
  where: Array<GebietsTypWhereUniqueInput>;
};


export type MutationDeleteGruppeArgs = {
  where: GruppeWhereUniqueInput;
};


export type MutationDeleteGruppenEigenschaftArgs = {
  where: GruppenEigenschaftWhereUniqueInput;
};


export type MutationDeleteGruppenEigenschaftsArgs = {
  where: Array<GruppenEigenschaftWhereUniqueInput>;
};


export type MutationDeleteGruppenTypArgs = {
  where: GruppenTypWhereUniqueInput;
};


export type MutationDeleteGruppenTypsArgs = {
  where: Array<GruppenTypWhereUniqueInput>;
};


export type MutationDeleteGruppesArgs = {
  where: Array<GruppeWhereUniqueInput>;
};


export type MutationDeleteHochzeitArgs = {
  where: HochzeitWhereUniqueInput;
};


export type MutationDeleteHochzeitsArgs = {
  where: Array<HochzeitWhereUniqueInput>;
};


export type MutationDeleteKirchenbuchArgs = {
  where: KirchenbuchWhereUniqueInput;
};


export type MutationDeleteKirchenbuchBildArgs = {
  where: KirchenbuchBildWhereUniqueInput;
};


export type MutationDeleteKirchenbuchBildsArgs = {
  where: Array<KirchenbuchBildWhereUniqueInput>;
};


export type MutationDeleteKirchenbuchTypArgs = {
  where: KirchenbuchTypWhereUniqueInput;
};


export type MutationDeleteKirchenbuchTypsArgs = {
  where: Array<KirchenbuchTypWhereUniqueInput>;
};


export type MutationDeleteKirchenbuchesArgs = {
  where: Array<KirchenbuchWhereUniqueInput>;
};


export type MutationDeleteObjektArgs = {
  where: ObjektWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftFotoArgs = {
  where: ObjektEigenschaftFotoWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftFotosArgs = {
  where: Array<ObjektEigenschaftFotoWhereUniqueInput>;
};


export type MutationDeleteObjektEigenschaftMaterialArgs = {
  where: ObjektEigenschaftMaterialWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftMaterialsArgs = {
  where: Array<ObjektEigenschaftMaterialWhereUniqueInput>;
};


export type MutationDeleteObjektEigenschaftPublikationArgs = {
  where: ObjektEigenschaftPublikationWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftPublikationsArgs = {
  where: Array<ObjektEigenschaftPublikationWhereUniqueInput>;
};


export type MutationDeleteObjektEigenschaftTechnikArgs = {
  where: ObjektEigenschaftTechnikWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftTechniksArgs = {
  where: Array<ObjektEigenschaftTechnikWhereUniqueInput>;
};


export type MutationDeleteObjektEigenschaftVolkskundeArgs = {
  where: ObjektEigenschaftVolkskundeWhereUniqueInput;
};


export type MutationDeleteObjektEigenschaftVolkskundesArgs = {
  where: Array<ObjektEigenschaftVolkskundeWhereUniqueInput>;
};


export type MutationDeleteObjektTypArgs = {
  where: ObjektTypWhereUniqueInput;
};


export type MutationDeleteObjektTypsArgs = {
  where: Array<ObjektTypWhereUniqueInput>;
};


export type MutationDeleteObjektsArgs = {
  where: Array<ObjektWhereUniqueInput>;
};


export type MutationDeleteOrtArgs = {
  where: OrtWhereUniqueInput;
};


export type MutationDeleteOrtTypArgs = {
  where: OrtTypWhereUniqueInput;
};


export type MutationDeleteOrtTypsArgs = {
  where: Array<OrtTypWhereUniqueInput>;
};


export type MutationDeleteOrtsArgs = {
  where: Array<OrtWhereUniqueInput>;
};


export type MutationDeleteOrtsEigenschaftArgs = {
  where: OrtsEigenschaftWhereUniqueInput;
};


export type MutationDeleteOrtsEigenschaftsArgs = {
  where: Array<OrtsEigenschaftWhereUniqueInput>;
};


export type MutationDeletePeopleArgs = {
  where: Array<PersonWhereUniqueInput>;
};


export type MutationDeletePersonArgs = {
  where: PersonWhereUniqueInput;
};


export type MutationDeletePersonenEigenschaftArgs = {
  where: PersonenEigenschaftWhereUniqueInput;
};


export type MutationDeletePersonenEigenschaftsArgs = {
  where: Array<PersonenEigenschaftWhereUniqueInput>;
};


export type MutationDeleteStatusArgs = {
  where: StatusWhereUniqueInput;
};


export type MutationDeleteStatusesArgs = {
  where: Array<StatusWhereUniqueInput>;
};


export type MutationDeleteSterbebildEigenschaftArgs = {
  where: SterbebildEigenschaftWhereUniqueInput;
};


export type MutationDeleteSterbebildEigenschaftsArgs = {
  where: Array<SterbebildEigenschaftWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationDeleteZeitspanneArgs = {
  where: ZeitspanneWhereUniqueInput;
};


export type MutationDeleteZeitspannesArgs = {
  where: Array<ZeitspanneWhereUniqueInput>;
};


export type MutationUpdateBerufsTypArgs = {
  data: BerufsTypUpdateInput;
  where: BerufsTypWhereUniqueInput;
};


export type MutationUpdateBerufsTypsArgs = {
  data: Array<BerufsTypUpdateArgs>;
};


export type MutationUpdateCopyrightTypArgs = {
  data: CopyrightTypUpdateInput;
  where: CopyrightTypWhereUniqueInput;
};


export type MutationUpdateCopyrightTypsArgs = {
  data: Array<CopyrightTypUpdateArgs>;
};


export type MutationUpdateEigentumArgs = {
  data: EigentumUpdateInput;
  where: EigentumWhereUniqueInput;
};


export type MutationUpdateEigentumsArgs = {
  data: Array<EigentumUpdateArgs>;
};


export type MutationUpdateEntstehungszeitArgs = {
  data: EntstehungszeitUpdateInput;
  where: EntstehungszeitWhereUniqueInput;
};


export type MutationUpdateEntstehungszeitsArgs = {
  data: Array<EntstehungszeitUpdateArgs>;
};


export type MutationUpdateEreignisArgs = {
  data: EreignisUpdateInput;
  where: EreignisWhereUniqueInput;
};


export type MutationUpdateEreignisEigenschaftArgs = {
  data: EreignisEigenschaftUpdateInput;
  where: EreignisEigenschaftWhereUniqueInput;
};


export type MutationUpdateEreignisEigenschaftsArgs = {
  data: Array<EreignisEigenschaftUpdateArgs>;
};


export type MutationUpdateEreignisTypArgs = {
  data: EreignisTypUpdateInput;
  where: EreignisTypWhereUniqueInput;
};


export type MutationUpdateEreignisTypsArgs = {
  data: Array<EreignisTypUpdateArgs>;
};


export type MutationUpdateEreignisseArgs = {
  data: Array<EreignisUpdateArgs>;
};


export type MutationUpdateFotoArgs = {
  data: FotoUpdateInput;
  where: FotoWhereUniqueInput;
};


export type MutationUpdateFotosArgs = {
  data: Array<FotoUpdateArgs>;
};


export type MutationUpdateGebietArgs = {
  data: GebietUpdateInput;
  where: GebietWhereUniqueInput;
};


export type MutationUpdateGebietsArgs = {
  data: Array<GebietUpdateArgs>;
};


export type MutationUpdateGebietsTypArgs = {
  data: GebietsTypUpdateInput;
  where: GebietsTypWhereUniqueInput;
};


export type MutationUpdateGebietsTypsArgs = {
  data: Array<GebietsTypUpdateArgs>;
};


export type MutationUpdateGruppeArgs = {
  data: GruppeUpdateInput;
  where: GruppeWhereUniqueInput;
};


export type MutationUpdateGruppenEigenschaftArgs = {
  data: GruppenEigenschaftUpdateInput;
  where: GruppenEigenschaftWhereUniqueInput;
};


export type MutationUpdateGruppenEigenschaftsArgs = {
  data: Array<GruppenEigenschaftUpdateArgs>;
};


export type MutationUpdateGruppenTypArgs = {
  data: GruppenTypUpdateInput;
  where: GruppenTypWhereUniqueInput;
};


export type MutationUpdateGruppenTypsArgs = {
  data: Array<GruppenTypUpdateArgs>;
};


export type MutationUpdateGruppesArgs = {
  data: Array<GruppeUpdateArgs>;
};


export type MutationUpdateHochzeitArgs = {
  data: HochzeitUpdateInput;
  where: HochzeitWhereUniqueInput;
};


export type MutationUpdateHochzeitsArgs = {
  data: Array<HochzeitUpdateArgs>;
};


export type MutationUpdateKirchenbuchArgs = {
  data: KirchenbuchUpdateInput;
  where: KirchenbuchWhereUniqueInput;
};


export type MutationUpdateKirchenbuchBildArgs = {
  data: KirchenbuchBildUpdateInput;
  where: KirchenbuchBildWhereUniqueInput;
};


export type MutationUpdateKirchenbuchBildsArgs = {
  data: Array<KirchenbuchBildUpdateArgs>;
};


export type MutationUpdateKirchenbuchTypArgs = {
  data: KirchenbuchTypUpdateInput;
  where: KirchenbuchTypWhereUniqueInput;
};


export type MutationUpdateKirchenbuchTypsArgs = {
  data: Array<KirchenbuchTypUpdateArgs>;
};


export type MutationUpdateKirchenbuchesArgs = {
  data: Array<KirchenbuchUpdateArgs>;
};


export type MutationUpdateObjektArgs = {
  data: ObjektUpdateInput;
  where: ObjektWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftFotoArgs = {
  data: ObjektEigenschaftFotoUpdateInput;
  where: ObjektEigenschaftFotoWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftFotosArgs = {
  data: Array<ObjektEigenschaftFotoUpdateArgs>;
};


export type MutationUpdateObjektEigenschaftMaterialArgs = {
  data: ObjektEigenschaftMaterialUpdateInput;
  where: ObjektEigenschaftMaterialWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftMaterialsArgs = {
  data: Array<ObjektEigenschaftMaterialUpdateArgs>;
};


export type MutationUpdateObjektEigenschaftPublikationArgs = {
  data: ObjektEigenschaftPublikationUpdateInput;
  where: ObjektEigenschaftPublikationWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftPublikationsArgs = {
  data: Array<ObjektEigenschaftPublikationUpdateArgs>;
};


export type MutationUpdateObjektEigenschaftTechnikArgs = {
  data: ObjektEigenschaftTechnikUpdateInput;
  where: ObjektEigenschaftTechnikWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftTechniksArgs = {
  data: Array<ObjektEigenschaftTechnikUpdateArgs>;
};


export type MutationUpdateObjektEigenschaftVolkskundeArgs = {
  data: ObjektEigenschaftVolkskundeUpdateInput;
  where: ObjektEigenschaftVolkskundeWhereUniqueInput;
};


export type MutationUpdateObjektEigenschaftVolkskundesArgs = {
  data: Array<ObjektEigenschaftVolkskundeUpdateArgs>;
};


export type MutationUpdateObjektTypArgs = {
  data: ObjektTypUpdateInput;
  where: ObjektTypWhereUniqueInput;
};


export type MutationUpdateObjektTypsArgs = {
  data: Array<ObjektTypUpdateArgs>;
};


export type MutationUpdateObjektsArgs = {
  data: Array<ObjektUpdateArgs>;
};


export type MutationUpdateOrtArgs = {
  data: OrtUpdateInput;
  where: OrtWhereUniqueInput;
};


export type MutationUpdateOrtTypArgs = {
  data: OrtTypUpdateInput;
  where: OrtTypWhereUniqueInput;
};


export type MutationUpdateOrtTypsArgs = {
  data: Array<OrtTypUpdateArgs>;
};


export type MutationUpdateOrtsArgs = {
  data: Array<OrtUpdateArgs>;
};


export type MutationUpdateOrtsEigenschaftArgs = {
  data: OrtsEigenschaftUpdateInput;
  where: OrtsEigenschaftWhereUniqueInput;
};


export type MutationUpdateOrtsEigenschaftsArgs = {
  data: Array<OrtsEigenschaftUpdateArgs>;
};


export type MutationUpdatePeopleArgs = {
  data: Array<PersonUpdateArgs>;
};


export type MutationUpdatePersonArgs = {
  data: PersonUpdateInput;
  where: PersonWhereUniqueInput;
};


export type MutationUpdatePersonenEigenschaftArgs = {
  data: PersonenEigenschaftUpdateInput;
  where: PersonenEigenschaftWhereUniqueInput;
};


export type MutationUpdatePersonenEigenschaftsArgs = {
  data: Array<PersonenEigenschaftUpdateArgs>;
};


export type MutationUpdateStatusArgs = {
  data: StatusUpdateInput;
  where: StatusWhereUniqueInput;
};


export type MutationUpdateStatusesArgs = {
  data: Array<StatusUpdateArgs>;
};


export type MutationUpdateSterbebildEigenschaftArgs = {
  data: SterbebildEigenschaftUpdateInput;
  where: SterbebildEigenschaftWhereUniqueInput;
};


export type MutationUpdateSterbebildEigenschaftsArgs = {
  data: Array<SterbebildEigenschaftUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationUpdateZeitspanneArgs = {
  data: ZeitspanneUpdateInput;
  where: ZeitspanneWhereUniqueInput;
};


export type MutationUpdateZeitspannesArgs = {
  data: Array<ZeitspanneUpdateArgs>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Objekt = {
  __typename?: 'Objekt';
  authorGroup?: Maybe<Array<Gruppe>>;
  authorGroupCount?: Maybe<Scalars['Int']['output']>;
  authorPerson?: Maybe<Array<Person>>;
  authorPersonCount?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Array<Person>>;
  clientCount?: Maybe<Scalars['Int']['output']>;
  contains?: Maybe<Array<Objekt>>;
  containsCount?: Maybe<Scalars['Int']['output']>;
  copyright?: Maybe<Array<CopyrightTyp>>;
  copyrightCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Objekt_Description_Document>;
  descriptionAuthor?: Maybe<Array<Person>>;
  descriptionAuthorCount?: Maybe<Scalars['Int']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  editorGroup?: Maybe<Array<Gruppe>>;
  editorGroupCount?: Maybe<Scalars['Int']['output']>;
  editorPerson?: Maybe<Array<Person>>;
  editorPersonCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenFoto?: Maybe<Array<ObjektEigenschaftFoto>>;
  eigenschaftenFotoCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenMaterial?: Maybe<Array<ObjektEigenschaftMaterial>>;
  eigenschaftenMaterialCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenPublikation?: Maybe<Array<ObjektEigenschaftPublikation>>;
  eigenschaftenPublikationCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenSterbebild?: Maybe<Array<SterbebildEigenschaft>>;
  eigenschaftenSterbebildCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenTechnik?: Maybe<Array<ObjektEigenschaftTechnik>>;
  eigenschaftenTechnikCount?: Maybe<Scalars['Int']['output']>;
  eigenschaftenVolkskunde?: Maybe<Array<ObjektEigenschaftVolkskunde>>;
  eigenschaftenVolkskundeCount?: Maybe<Scalars['Int']['output']>;
  groupsOnWork?: Maybe<Array<Gruppe>>;
  groupsOnWorkCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageObjects?: Maybe<Array<Objekt>>;
  imageObjectsCount?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Foto>>;
  imagesCount?: Maybe<Scalars['Int']['output']>;
  importTimestamp?: Maybe<Scalars['String']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  locationOnWork?: Maybe<Array<Ort>>;
  locationOnWorkCount?: Maybe<Scalars['Int']['output']>;
  locationToday?: Maybe<Ort>;
  notes?: Maybe<Objekt_Notes_Document>;
  otherTitles?: Maybe<Scalars['String']['output']>;
  ownerships?: Maybe<Array<Eigentum>>;
  ownershipsCount?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<Array<Objekt>>;
  partOfCount?: Maybe<Scalars['Int']['output']>;
  periodOfOrigin?: Maybe<Entstehungszeit>;
  personsOnWork?: Maybe<Array<Person>>;
  personsOnWorkCount?: Maybe<Scalars['Int']['output']>;
  place?: Maybe<Ort>;
  printer?: Maybe<Scalars['String']['output']>;
  producerGroup?: Maybe<Array<Gruppe>>;
  producerGroupCount?: Maybe<Scalars['Int']['output']>;
  producerPerson?: Maybe<Array<Person>>;
  producerPersonCount?: Maybe<Scalars['Int']['output']>;
  publisher?: Maybe<Scalars['String']['output']>;
  similarTo?: Maybe<Array<Objekt>>;
  similarToCount?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Objekt_Sources_Document>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typ?: Maybe<Array<ObjektTyp>>;
  typCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  weblinks?: Maybe<Objekt_Weblinks_Document>;
  zustaende?: Maybe<Array<Status>>;
  zustaendeCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektAuthorGroupArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type ObjektAuthorGroupCountArgs = {
  where?: GruppeWhereInput;
};


export type ObjektAuthorPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektAuthorPersonCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektClientArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektClientCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektContainsArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektContainsCountArgs = {
  where?: ObjektWhereInput;
};


export type ObjektCopyrightArgs = {
  cursor?: InputMaybe<CopyrightTypWhereUniqueInput>;
  orderBy?: Array<CopyrightTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CopyrightTypWhereInput;
};


export type ObjektCopyrightCountArgs = {
  where?: CopyrightTypWhereInput;
};


export type ObjektDescriptionAuthorArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektDescriptionAuthorCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektEditorGroupArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type ObjektEditorGroupCountArgs = {
  where?: GruppeWhereInput;
};


export type ObjektEditorPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektEditorPersonCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektEigenschaftenFotoArgs = {
  cursor?: InputMaybe<ObjektEigenschaftFotoWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftFotoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftFotoWhereInput;
};


export type ObjektEigenschaftenFotoCountArgs = {
  where?: ObjektEigenschaftFotoWhereInput;
};


export type ObjektEigenschaftenMaterialArgs = {
  cursor?: InputMaybe<ObjektEigenschaftMaterialWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftMaterialOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftMaterialWhereInput;
};


export type ObjektEigenschaftenMaterialCountArgs = {
  where?: ObjektEigenschaftMaterialWhereInput;
};


export type ObjektEigenschaftenPublikationArgs = {
  cursor?: InputMaybe<ObjektEigenschaftPublikationWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftPublikationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftPublikationWhereInput;
};


export type ObjektEigenschaftenPublikationCountArgs = {
  where?: ObjektEigenschaftPublikationWhereInput;
};


export type ObjektEigenschaftenSterbebildArgs = {
  cursor?: InputMaybe<SterbebildEigenschaftWhereUniqueInput>;
  orderBy?: Array<SterbebildEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SterbebildEigenschaftWhereInput;
};


export type ObjektEigenschaftenSterbebildCountArgs = {
  where?: SterbebildEigenschaftWhereInput;
};


export type ObjektEigenschaftenTechnikArgs = {
  cursor?: InputMaybe<ObjektEigenschaftTechnikWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftTechnikOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftTechnikWhereInput;
};


export type ObjektEigenschaftenTechnikCountArgs = {
  where?: ObjektEigenschaftTechnikWhereInput;
};


export type ObjektEigenschaftenVolkskundeArgs = {
  cursor?: InputMaybe<ObjektEigenschaftVolkskundeWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftVolkskundeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftVolkskundeWhereInput;
};


export type ObjektEigenschaftenVolkskundeCountArgs = {
  where?: ObjektEigenschaftVolkskundeWhereInput;
};


export type ObjektGroupsOnWorkArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type ObjektGroupsOnWorkCountArgs = {
  where?: GruppeWhereInput;
};


export type ObjektImageObjectsArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektImageObjectsCountArgs = {
  where?: ObjektWhereInput;
};


export type ObjektImagesArgs = {
  cursor?: InputMaybe<FotoWhereUniqueInput>;
  orderBy?: Array<FotoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: FotoWhereInput;
};


export type ObjektImagesCountArgs = {
  where?: FotoWhereInput;
};


export type ObjektLocationOnWorkArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type ObjektLocationOnWorkCountArgs = {
  where?: OrtWhereInput;
};


export type ObjektOwnershipsArgs = {
  cursor?: InputMaybe<EigentumWhereUniqueInput>;
  orderBy?: Array<EigentumOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EigentumWhereInput;
};


export type ObjektOwnershipsCountArgs = {
  where?: EigentumWhereInput;
};


export type ObjektPartOfArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektPartOfCountArgs = {
  where?: ObjektWhereInput;
};


export type ObjektPersonsOnWorkArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektPersonsOnWorkCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektProducerGroupArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type ObjektProducerGroupCountArgs = {
  where?: GruppeWhereInput;
};


export type ObjektProducerPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type ObjektProducerPersonCountArgs = {
  where?: PersonWhereInput;
};


export type ObjektSimilarToArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektSimilarToCountArgs = {
  where?: ObjektWhereInput;
};


export type ObjektTypArgs = {
  cursor?: InputMaybe<ObjektTypWhereUniqueInput>;
  orderBy?: Array<ObjektTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektTypWhereInput;
};


export type ObjektTypCountArgs = {
  where?: ObjektTypWhereInput;
};


export type ObjektZustaendeArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type ObjektZustaendeCountArgs = {
  where?: StatusWhereInput;
};

export type ObjektCreateInput = {
  authorGroup?: InputMaybe<GruppeRelateToManyForCreateInput>;
  authorPerson?: InputMaybe<PersonRelateToManyForCreateInput>;
  client?: InputMaybe<PersonRelateToManyForCreateInput>;
  contains?: InputMaybe<ObjektRelateToManyForCreateInput>;
  copyright?: InputMaybe<CopyrightTypRelateToManyForCreateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  descriptionAuthor?: InputMaybe<PersonRelateToManyForCreateInput>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  editorGroup?: InputMaybe<GruppeRelateToManyForCreateInput>;
  editorPerson?: InputMaybe<PersonRelateToManyForCreateInput>;
  eigenschaftenFoto?: InputMaybe<ObjektEigenschaftFotoRelateToManyForCreateInput>;
  eigenschaftenMaterial?: InputMaybe<ObjektEigenschaftMaterialRelateToManyForCreateInput>;
  eigenschaftenPublikation?: InputMaybe<ObjektEigenschaftPublikationRelateToManyForCreateInput>;
  eigenschaftenSterbebild?: InputMaybe<SterbebildEigenschaftRelateToManyForCreateInput>;
  eigenschaftenTechnik?: InputMaybe<ObjektEigenschaftTechnikRelateToManyForCreateInput>;
  eigenschaftenVolkskunde?: InputMaybe<ObjektEigenschaftVolkskundeRelateToManyForCreateInput>;
  groupsOnWork?: InputMaybe<GruppeRelateToManyForCreateInput>;
  imageObjects?: InputMaybe<ObjektRelateToManyForCreateInput>;
  images?: InputMaybe<FotoRelateToManyForCreateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  locationOnWork?: InputMaybe<OrtRelateToManyForCreateInput>;
  locationToday?: InputMaybe<OrtRelateToOneForCreateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  otherTitles?: InputMaybe<Scalars['String']['input']>;
  ownerships?: InputMaybe<EigentumRelateToManyForCreateInput>;
  pages?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<ObjektRelateToManyForCreateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForCreateInput>;
  personsOnWork?: InputMaybe<PersonRelateToManyForCreateInput>;
  place?: InputMaybe<OrtRelateToOneForCreateInput>;
  printer?: InputMaybe<Scalars['String']['input']>;
  producerGroup?: InputMaybe<GruppeRelateToManyForCreateInput>;
  producerPerson?: InputMaybe<PersonRelateToManyForCreateInput>;
  publisher?: InputMaybe<Scalars['String']['input']>;
  similarTo?: InputMaybe<ObjektRelateToManyForCreateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typ?: InputMaybe<ObjektTypRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForCreateInput>;
};

export type ObjektEigenschaftFoto = {
  __typename?: 'ObjektEigenschaftFoto';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektEigenschaftFotoObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektEigenschaftFotoObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type ObjektEigenschaftFotoCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type ObjektEigenschaftFotoManyRelationFilter = {
  every?: InputMaybe<ObjektEigenschaftFotoWhereInput>;
  none?: InputMaybe<ObjektEigenschaftFotoWhereInput>;
  some?: InputMaybe<ObjektEigenschaftFotoWhereInput>;
};

export type ObjektEigenschaftFotoOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektEigenschaftFotoRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftFotoWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftFotoCreateInput>>;
};

export type ObjektEigenschaftFotoRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftFotoWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftFotoCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektEigenschaftFotoWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektEigenschaftFotoWhereUniqueInput>>;
};

export type ObjektEigenschaftFotoUpdateArgs = {
  data: ObjektEigenschaftFotoUpdateInput;
  where: ObjektEigenschaftFotoWhereUniqueInput;
};

export type ObjektEigenschaftFotoUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type ObjektEigenschaftFotoWhereInput = {
  AND?: InputMaybe<Array<ObjektEigenschaftFotoWhereInput>>;
  NOT?: InputMaybe<Array<ObjektEigenschaftFotoWhereInput>>;
  OR?: InputMaybe<Array<ObjektEigenschaftFotoWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type ObjektEigenschaftFotoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjektEigenschaftMaterial = {
  __typename?: 'ObjektEigenschaftMaterial';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektEigenschaftMaterialObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektEigenschaftMaterialObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type ObjektEigenschaftMaterialCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type ObjektEigenschaftMaterialManyRelationFilter = {
  every?: InputMaybe<ObjektEigenschaftMaterialWhereInput>;
  none?: InputMaybe<ObjektEigenschaftMaterialWhereInput>;
  some?: InputMaybe<ObjektEigenschaftMaterialWhereInput>;
};

export type ObjektEigenschaftMaterialOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektEigenschaftMaterialRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftMaterialWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftMaterialCreateInput>>;
};

export type ObjektEigenschaftMaterialRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftMaterialWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftMaterialCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektEigenschaftMaterialWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektEigenschaftMaterialWhereUniqueInput>>;
};

export type ObjektEigenschaftMaterialUpdateArgs = {
  data: ObjektEigenschaftMaterialUpdateInput;
  where: ObjektEigenschaftMaterialWhereUniqueInput;
};

export type ObjektEigenschaftMaterialUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type ObjektEigenschaftMaterialWhereInput = {
  AND?: InputMaybe<Array<ObjektEigenschaftMaterialWhereInput>>;
  NOT?: InputMaybe<Array<ObjektEigenschaftMaterialWhereInput>>;
  OR?: InputMaybe<Array<ObjektEigenschaftMaterialWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type ObjektEigenschaftMaterialWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjektEigenschaftPublikation = {
  __typename?: 'ObjektEigenschaftPublikation';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektEigenschaftPublikationObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektEigenschaftPublikationObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type ObjektEigenschaftPublikationCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type ObjektEigenschaftPublikationManyRelationFilter = {
  every?: InputMaybe<ObjektEigenschaftPublikationWhereInput>;
  none?: InputMaybe<ObjektEigenschaftPublikationWhereInput>;
  some?: InputMaybe<ObjektEigenschaftPublikationWhereInput>;
};

export type ObjektEigenschaftPublikationOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektEigenschaftPublikationRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftPublikationWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftPublikationCreateInput>>;
};

export type ObjektEigenschaftPublikationRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftPublikationWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftPublikationCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektEigenschaftPublikationWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektEigenschaftPublikationWhereUniqueInput>>;
};

export type ObjektEigenschaftPublikationUpdateArgs = {
  data: ObjektEigenschaftPublikationUpdateInput;
  where: ObjektEigenschaftPublikationWhereUniqueInput;
};

export type ObjektEigenschaftPublikationUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type ObjektEigenschaftPublikationWhereInput = {
  AND?: InputMaybe<Array<ObjektEigenschaftPublikationWhereInput>>;
  NOT?: InputMaybe<Array<ObjektEigenschaftPublikationWhereInput>>;
  OR?: InputMaybe<Array<ObjektEigenschaftPublikationWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type ObjektEigenschaftPublikationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjektEigenschaftTechnik = {
  __typename?: 'ObjektEigenschaftTechnik';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektEigenschaftTechnikObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektEigenschaftTechnikObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type ObjektEigenschaftTechnikCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type ObjektEigenschaftTechnikManyRelationFilter = {
  every?: InputMaybe<ObjektEigenschaftTechnikWhereInput>;
  none?: InputMaybe<ObjektEigenschaftTechnikWhereInput>;
  some?: InputMaybe<ObjektEigenschaftTechnikWhereInput>;
};

export type ObjektEigenschaftTechnikOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektEigenschaftTechnikRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftTechnikWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftTechnikCreateInput>>;
};

export type ObjektEigenschaftTechnikRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftTechnikWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftTechnikCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektEigenschaftTechnikWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektEigenschaftTechnikWhereUniqueInput>>;
};

export type ObjektEigenschaftTechnikUpdateArgs = {
  data: ObjektEigenschaftTechnikUpdateInput;
  where: ObjektEigenschaftTechnikWhereUniqueInput;
};

export type ObjektEigenschaftTechnikUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type ObjektEigenschaftTechnikWhereInput = {
  AND?: InputMaybe<Array<ObjektEigenschaftTechnikWhereInput>>;
  NOT?: InputMaybe<Array<ObjektEigenschaftTechnikWhereInput>>;
  OR?: InputMaybe<Array<ObjektEigenschaftTechnikWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type ObjektEigenschaftTechnikWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjektEigenschaftVolkskunde = {
  __typename?: 'ObjektEigenschaftVolkskunde';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type ObjektEigenschaftVolkskundeObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type ObjektEigenschaftVolkskundeObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type ObjektEigenschaftVolkskundeCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type ObjektEigenschaftVolkskundeManyRelationFilter = {
  every?: InputMaybe<ObjektEigenschaftVolkskundeWhereInput>;
  none?: InputMaybe<ObjektEigenschaftVolkskundeWhereInput>;
  some?: InputMaybe<ObjektEigenschaftVolkskundeWhereInput>;
};

export type ObjektEigenschaftVolkskundeOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektEigenschaftVolkskundeRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftVolkskundeCreateInput>>;
};

export type ObjektEigenschaftVolkskundeRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektEigenschaftVolkskundeCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereUniqueInput>>;
};

export type ObjektEigenschaftVolkskundeUpdateArgs = {
  data: ObjektEigenschaftVolkskundeUpdateInput;
  where: ObjektEigenschaftVolkskundeWhereUniqueInput;
};

export type ObjektEigenschaftVolkskundeUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type ObjektEigenschaftVolkskundeWhereInput = {
  AND?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereInput>>;
  NOT?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereInput>>;
  OR?: InputMaybe<Array<ObjektEigenschaftVolkskundeWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type ObjektEigenschaftVolkskundeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ObjektManyRelationFilter = {
  every?: InputMaybe<ObjektWhereInput>;
  none?: InputMaybe<ObjektWhereInput>;
  some?: InputMaybe<ObjektWhereInput>;
};

export type ObjektOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  dimensions?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  importTimestamp?: InputMaybe<OrderDirection>;
  isbn?: InputMaybe<OrderDirection>;
  otherTitles?: InputMaybe<OrderDirection>;
  pages?: InputMaybe<OrderDirection>;
  printer?: InputMaybe<OrderDirection>;
  publisher?: InputMaybe<OrderDirection>;
  subtitle?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type ObjektRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektCreateInput>>;
};

export type ObjektRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektWhereUniqueInput>>;
};

export type ObjektRelateToOneForCreateInput = {
  connect?: InputMaybe<ObjektWhereUniqueInput>;
  create?: InputMaybe<ObjektCreateInput>;
};

export type ObjektRelateToOneForUpdateInput = {
  connect?: InputMaybe<ObjektWhereUniqueInput>;
  create?: InputMaybe<ObjektCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ObjektTyp = {
  __typename?: 'ObjektTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ObjektTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ObjektTypManyRelationFilter = {
  every?: InputMaybe<ObjektTypWhereInput>;
  none?: InputMaybe<ObjektTypWhereInput>;
  some?: InputMaybe<ObjektTypWhereInput>;
};

export type ObjektTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObjektTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ObjektTypWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektTypCreateInput>>;
};

export type ObjektTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ObjektTypWhereUniqueInput>>;
  create?: InputMaybe<Array<ObjektTypCreateInput>>;
  disconnect?: InputMaybe<Array<ObjektTypWhereUniqueInput>>;
  set?: InputMaybe<Array<ObjektTypWhereUniqueInput>>;
};

export type ObjektTypUpdateArgs = {
  data: ObjektTypUpdateInput;
  where: ObjektTypWhereUniqueInput;
};

export type ObjektTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ObjektTypWhereInput = {
  AND?: InputMaybe<Array<ObjektTypWhereInput>>;
  NOT?: InputMaybe<Array<ObjektTypWhereInput>>;
  OR?: InputMaybe<Array<ObjektTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ObjektTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ObjektUpdateArgs = {
  data: ObjektUpdateInput;
  where: ObjektWhereUniqueInput;
};

export type ObjektUpdateInput = {
  authorGroup?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  authorPerson?: InputMaybe<PersonRelateToManyForUpdateInput>;
  client?: InputMaybe<PersonRelateToManyForUpdateInput>;
  contains?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  copyright?: InputMaybe<CopyrightTypRelateToManyForUpdateInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  descriptionAuthor?: InputMaybe<PersonRelateToManyForUpdateInput>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  editorGroup?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  editorPerson?: InputMaybe<PersonRelateToManyForUpdateInput>;
  eigenschaftenFoto?: InputMaybe<ObjektEigenschaftFotoRelateToManyForUpdateInput>;
  eigenschaftenMaterial?: InputMaybe<ObjektEigenschaftMaterialRelateToManyForUpdateInput>;
  eigenschaftenPublikation?: InputMaybe<ObjektEigenschaftPublikationRelateToManyForUpdateInput>;
  eigenschaftenSterbebild?: InputMaybe<SterbebildEigenschaftRelateToManyForUpdateInput>;
  eigenschaftenTechnik?: InputMaybe<ObjektEigenschaftTechnikRelateToManyForUpdateInput>;
  eigenschaftenVolkskunde?: InputMaybe<ObjektEigenschaftVolkskundeRelateToManyForUpdateInput>;
  groupsOnWork?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  imageObjects?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  images?: InputMaybe<FotoRelateToManyForUpdateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  locationOnWork?: InputMaybe<OrtRelateToManyForUpdateInput>;
  locationToday?: InputMaybe<OrtRelateToOneForUpdateInput>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  otherTitles?: InputMaybe<Scalars['String']['input']>;
  ownerships?: InputMaybe<EigentumRelateToManyForUpdateInput>;
  pages?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  periodOfOrigin?: InputMaybe<EntstehungszeitRelateToOneForUpdateInput>;
  personsOnWork?: InputMaybe<PersonRelateToManyForUpdateInput>;
  place?: InputMaybe<OrtRelateToOneForUpdateInput>;
  printer?: InputMaybe<Scalars['String']['input']>;
  producerGroup?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  producerPerson?: InputMaybe<PersonRelateToManyForUpdateInput>;
  publisher?: InputMaybe<Scalars['String']['input']>;
  similarTo?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typ?: InputMaybe<ObjektTypRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForUpdateInput>;
};

export type ObjektWhereInput = {
  AND?: InputMaybe<Array<ObjektWhereInput>>;
  NOT?: InputMaybe<Array<ObjektWhereInput>>;
  OR?: InputMaybe<Array<ObjektWhereInput>>;
  authorGroup?: InputMaybe<GruppeManyRelationFilter>;
  authorPerson?: InputMaybe<PersonManyRelationFilter>;
  client?: InputMaybe<PersonManyRelationFilter>;
  contains?: InputMaybe<ObjektManyRelationFilter>;
  copyright?: InputMaybe<CopyrightTypManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  descriptionAuthor?: InputMaybe<PersonManyRelationFilter>;
  dimensions?: InputMaybe<StringFilter>;
  editorGroup?: InputMaybe<GruppeManyRelationFilter>;
  editorPerson?: InputMaybe<PersonManyRelationFilter>;
  eigenschaftenFoto?: InputMaybe<ObjektEigenschaftFotoManyRelationFilter>;
  eigenschaftenMaterial?: InputMaybe<ObjektEigenschaftMaterialManyRelationFilter>;
  eigenschaftenPublikation?: InputMaybe<ObjektEigenschaftPublikationManyRelationFilter>;
  eigenschaftenSterbebild?: InputMaybe<SterbebildEigenschaftManyRelationFilter>;
  eigenschaftenTechnik?: InputMaybe<ObjektEigenschaftTechnikManyRelationFilter>;
  eigenschaftenVolkskunde?: InputMaybe<ObjektEigenschaftVolkskundeManyRelationFilter>;
  groupsOnWork?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  imageObjects?: InputMaybe<ObjektManyRelationFilter>;
  images?: InputMaybe<FotoManyRelationFilter>;
  importTimestamp?: InputMaybe<StringFilter>;
  isbn?: InputMaybe<StringFilter>;
  locationOnWork?: InputMaybe<OrtManyRelationFilter>;
  locationToday?: InputMaybe<OrtWhereInput>;
  otherTitles?: InputMaybe<StringFilter>;
  ownerships?: InputMaybe<EigentumManyRelationFilter>;
  pages?: InputMaybe<StringFilter>;
  partOf?: InputMaybe<ObjektManyRelationFilter>;
  periodOfOrigin?: InputMaybe<EntstehungszeitWhereInput>;
  personsOnWork?: InputMaybe<PersonManyRelationFilter>;
  place?: InputMaybe<OrtWhereInput>;
  printer?: InputMaybe<StringFilter>;
  producerGroup?: InputMaybe<GruppeManyRelationFilter>;
  producerPerson?: InputMaybe<PersonManyRelationFilter>;
  publisher?: InputMaybe<StringFilter>;
  similarTo?: InputMaybe<ObjektManyRelationFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  typ?: InputMaybe<ObjektTypManyRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  zustaende?: InputMaybe<StatusManyRelationFilter>;
};

export type ObjektWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Objekt_Description_Document = {
  __typename?: 'Objekt_description_Document';
  document: Scalars['JSON']['output'];
};


export type Objekt_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Objekt_Notes_Document = {
  __typename?: 'Objekt_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Objekt_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Objekt_Sources_Document = {
  __typename?: 'Objekt_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Objekt_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Objekt_Weblinks_Document = {
  __typename?: 'Objekt_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Objekt_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Ort = {
  __typename?: 'Ort';
  address?: Maybe<Scalars['String']['output']>;
  addressOld?: Maybe<Scalars['String']['output']>;
  addressOlder?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Gebiet>;
  bp?: Maybe<Scalars['String']['output']>;
  bpOld?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Ort_Description_Document>;
  displayName?: Maybe<Scalars['String']['output']>;
  eigenschaften?: Maybe<Array<OrtsEigenschaft>>;
  eigenschaftenCount?: Maybe<Scalars['Int']['output']>;
  eventLocationOnEvent?: Maybe<Array<Ereignis>>;
  eventLocationOnEventCount?: Maybe<Scalars['Int']['output']>;
  eventPlace?: Maybe<Array<Ereignis>>;
  eventPlaceCount?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gps?: Maybe<Scalars['String']['output']>;
  groupPlaces?: Maybe<Array<Gruppe>>;
  groupPlacesCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Objekt>;
  importTimestamp?: Maybe<Scalars['String']['output']>;
  kat?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nativeNames?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Ort_Notes_Document>;
  objectLocationOnWork?: Maybe<Array<Objekt>>;
  objectLocationOnWorkCount?: Maybe<Scalars['Int']['output']>;
  objectLocationToday?: Maybe<Array<Objekt>>;
  objectLocationTodayCount?: Maybe<Scalars['Int']['output']>;
  objectPlace?: Maybe<Array<Objekt>>;
  objectPlaceCount?: Maybe<Scalars['Int']['output']>;
  personenPlaceOfBirth?: Maybe<Array<Person>>;
  personenPlaceOfBirthCount?: Maybe<Scalars['Int']['output']>;
  personenPlaceOfDeath?: Maybe<Array<Person>>;
  personenPlaceOfDeathCount?: Maybe<Scalars['Int']['output']>;
  placeOfWedding?: Maybe<Array<Hochzeit>>;
  placeOfWeddingCount?: Maybe<Scalars['Int']['output']>;
  related?: Maybe<Array<Ort>>;
  relatedBy?: Maybe<Array<Ort>>;
  relatedByCount?: Maybe<Scalars['Int']['output']>;
  relatedCount?: Maybe<Scalars['Int']['output']>;
  sources?: Maybe<Ort_Sources_Document>;
  tarneller?: Maybe<Ort_Tarneller_Document>;
  typen?: Maybe<Array<OrtTyp>>;
  typenCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  weblinks?: Maybe<Ort_Weblinks_Document>;
  zustaende?: Maybe<Array<Status>>;
  zustaendeCount?: Maybe<Scalars['Int']['output']>;
};


export type OrtEigenschaftenArgs = {
  cursor?: InputMaybe<OrtsEigenschaftWhereUniqueInput>;
  orderBy?: Array<OrtsEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtsEigenschaftWhereInput;
};


export type OrtEigenschaftenCountArgs = {
  where?: OrtsEigenschaftWhereInput;
};


export type OrtEventLocationOnEventArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type OrtEventLocationOnEventCountArgs = {
  where?: EreignisWhereInput;
};


export type OrtEventPlaceArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type OrtEventPlaceCountArgs = {
  where?: EreignisWhereInput;
};


export type OrtGroupPlacesArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type OrtGroupPlacesCountArgs = {
  where?: GruppeWhereInput;
};


export type OrtObjectLocationOnWorkArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type OrtObjectLocationOnWorkCountArgs = {
  where?: ObjektWhereInput;
};


export type OrtObjectLocationTodayArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type OrtObjectLocationTodayCountArgs = {
  where?: ObjektWhereInput;
};


export type OrtObjectPlaceArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type OrtObjectPlaceCountArgs = {
  where?: ObjektWhereInput;
};


export type OrtPersonenPlaceOfBirthArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type OrtPersonenPlaceOfBirthCountArgs = {
  where?: PersonWhereInput;
};


export type OrtPersonenPlaceOfDeathArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type OrtPersonenPlaceOfDeathCountArgs = {
  where?: PersonWhereInput;
};


export type OrtPlaceOfWeddingArgs = {
  cursor?: InputMaybe<HochzeitWhereUniqueInput>;
  orderBy?: Array<HochzeitOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: HochzeitWhereInput;
};


export type OrtPlaceOfWeddingCountArgs = {
  where?: HochzeitWhereInput;
};


export type OrtRelatedArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type OrtRelatedByArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type OrtRelatedByCountArgs = {
  where?: OrtWhereInput;
};


export type OrtRelatedCountArgs = {
  where?: OrtWhereInput;
};


export type OrtTypenArgs = {
  cursor?: InputMaybe<OrtTypWhereUniqueInput>;
  orderBy?: Array<OrtTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtTypWhereInput;
};


export type OrtTypenCountArgs = {
  where?: OrtTypWhereInput;
};


export type OrtZustaendeArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type OrtZustaendeCountArgs = {
  where?: StatusWhereInput;
};

export type OrtCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressOld?: InputMaybe<Scalars['String']['input']>;
  addressOlder?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<GebietRelateToOneForCreateInput>;
  bp?: InputMaybe<Scalars['String']['input']>;
  bpOld?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<OrtsEigenschaftRelateToManyForCreateInput>;
  eventLocationOnEvent?: InputMaybe<EreignisRelateToManyForCreateInput>;
  eventPlace?: InputMaybe<EreignisRelateToManyForCreateInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gps?: InputMaybe<Scalars['String']['input']>;
  groupPlaces?: InputMaybe<GruppeRelateToManyForCreateInput>;
  images?: InputMaybe<ObjektRelateToOneForCreateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  kat?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nativeNames?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectLocationOnWork?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectLocationToday?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectPlace?: InputMaybe<ObjektRelateToManyForCreateInput>;
  personenPlaceOfBirth?: InputMaybe<PersonRelateToManyForCreateInput>;
  personenPlaceOfDeath?: InputMaybe<PersonRelateToManyForCreateInput>;
  placeOfWedding?: InputMaybe<HochzeitRelateToManyForCreateInput>;
  related?: InputMaybe<OrtRelateToManyForCreateInput>;
  relatedBy?: InputMaybe<OrtRelateToManyForCreateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  tarneller?: InputMaybe<Scalars['JSON']['input']>;
  typen?: InputMaybe<OrtTypRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForCreateInput>;
};

export type OrtManyRelationFilter = {
  every?: InputMaybe<OrtWhereInput>;
  none?: InputMaybe<OrtWhereInput>;
  some?: InputMaybe<OrtWhereInput>;
};

export type OrtOrderByInput = {
  address?: InputMaybe<OrderDirection>;
  addressOld?: InputMaybe<OrderDirection>;
  addressOlder?: InputMaybe<OrderDirection>;
  bp?: InputMaybe<OrderDirection>;
  bpOld?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  fullName?: InputMaybe<OrderDirection>;
  gps?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  importTimestamp?: InputMaybe<OrderDirection>;
  kat?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  nativeNames?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type OrtRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<OrtWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtCreateInput>>;
};

export type OrtRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<OrtWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtCreateInput>>;
  disconnect?: InputMaybe<Array<OrtWhereUniqueInput>>;
  set?: InputMaybe<Array<OrtWhereUniqueInput>>;
};

export type OrtRelateToOneForCreateInput = {
  connect?: InputMaybe<OrtWhereUniqueInput>;
  create?: InputMaybe<OrtCreateInput>;
};

export type OrtRelateToOneForUpdateInput = {
  connect?: InputMaybe<OrtWhereUniqueInput>;
  create?: InputMaybe<OrtCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrtTyp = {
  __typename?: 'OrtTyp';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrtTypCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrtTypManyRelationFilter = {
  every?: InputMaybe<OrtTypWhereInput>;
  none?: InputMaybe<OrtTypWhereInput>;
  some?: InputMaybe<OrtTypWhereInput>;
};

export type OrtTypOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type OrtTypRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<OrtTypWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtTypCreateInput>>;
};

export type OrtTypRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<OrtTypWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtTypCreateInput>>;
  disconnect?: InputMaybe<Array<OrtTypWhereUniqueInput>>;
  set?: InputMaybe<Array<OrtTypWhereUniqueInput>>;
};

export type OrtTypUpdateArgs = {
  data: OrtTypUpdateInput;
  where: OrtTypWhereUniqueInput;
};

export type OrtTypUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrtTypWhereInput = {
  AND?: InputMaybe<Array<OrtTypWhereInput>>;
  NOT?: InputMaybe<Array<OrtTypWhereInput>>;
  OR?: InputMaybe<Array<OrtTypWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type OrtTypWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrtUpdateArgs = {
  data: OrtUpdateInput;
  where: OrtWhereUniqueInput;
};

export type OrtUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressOld?: InputMaybe<Scalars['String']['input']>;
  addressOlder?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<GebietRelateToOneForUpdateInput>;
  bp?: InputMaybe<Scalars['String']['input']>;
  bpOld?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<OrtsEigenschaftRelateToManyForUpdateInput>;
  eventLocationOnEvent?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  eventPlace?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gps?: InputMaybe<Scalars['String']['input']>;
  groupPlaces?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  images?: InputMaybe<ObjektRelateToOneForUpdateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  kat?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nativeNames?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  objectLocationOnWork?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectLocationToday?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectPlace?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  personenPlaceOfBirth?: InputMaybe<PersonRelateToManyForUpdateInput>;
  personenPlaceOfDeath?: InputMaybe<PersonRelateToManyForUpdateInput>;
  placeOfWedding?: InputMaybe<HochzeitRelateToManyForUpdateInput>;
  related?: InputMaybe<OrtRelateToManyForUpdateInput>;
  relatedBy?: InputMaybe<OrtRelateToManyForUpdateInput>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  tarneller?: InputMaybe<Scalars['JSON']['input']>;
  typen?: InputMaybe<OrtTypRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  zustaende?: InputMaybe<StatusRelateToManyForUpdateInput>;
};

export type OrtWhereInput = {
  AND?: InputMaybe<Array<OrtWhereInput>>;
  NOT?: InputMaybe<Array<OrtWhereInput>>;
  OR?: InputMaybe<Array<OrtWhereInput>>;
  address?: InputMaybe<StringFilter>;
  addressOld?: InputMaybe<StringFilter>;
  addressOlder?: InputMaybe<StringFilter>;
  area?: InputMaybe<GebietWhereInput>;
  bp?: InputMaybe<StringFilter>;
  bpOld?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  eigenschaften?: InputMaybe<OrtsEigenschaftManyRelationFilter>;
  eventLocationOnEvent?: InputMaybe<EreignisManyRelationFilter>;
  eventPlace?: InputMaybe<EreignisManyRelationFilter>;
  fullName?: InputMaybe<StringFilter>;
  gps?: InputMaybe<StringFilter>;
  groupPlaces?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  images?: InputMaybe<ObjektWhereInput>;
  importTimestamp?: InputMaybe<StringFilter>;
  kat?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nativeNames?: InputMaybe<StringFilter>;
  objectLocationOnWork?: InputMaybe<ObjektManyRelationFilter>;
  objectLocationToday?: InputMaybe<ObjektManyRelationFilter>;
  objectPlace?: InputMaybe<ObjektManyRelationFilter>;
  personenPlaceOfBirth?: InputMaybe<PersonManyRelationFilter>;
  personenPlaceOfDeath?: InputMaybe<PersonManyRelationFilter>;
  placeOfWedding?: InputMaybe<HochzeitManyRelationFilter>;
  related?: InputMaybe<OrtManyRelationFilter>;
  relatedBy?: InputMaybe<OrtManyRelationFilter>;
  typen?: InputMaybe<OrtTypManyRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  zustaende?: InputMaybe<StatusManyRelationFilter>;
};

export type OrtWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Ort_Description_Document = {
  __typename?: 'Ort_description_Document';
  document: Scalars['JSON']['output'];
};


export type Ort_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ort_Notes_Document = {
  __typename?: 'Ort_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Ort_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ort_Sources_Document = {
  __typename?: 'Ort_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Ort_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ort_Tarneller_Document = {
  __typename?: 'Ort_tarneller_Document';
  document: Scalars['JSON']['output'];
};


export type Ort_Tarneller_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Ort_Weblinks_Document = {
  __typename?: 'Ort_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Ort_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type OrtsEigenschaft = {
  __typename?: 'OrtsEigenschaft';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orte?: Maybe<Array<Ort>>;
  orteCount?: Maybe<Scalars['Int']['output']>;
};


export type OrtsEigenschaftOrteArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type OrtsEigenschaftOrteCountArgs = {
  where?: OrtWhereInput;
};

export type OrtsEigenschaftCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  orte?: InputMaybe<OrtRelateToManyForCreateInput>;
};

export type OrtsEigenschaftManyRelationFilter = {
  every?: InputMaybe<OrtsEigenschaftWhereInput>;
  none?: InputMaybe<OrtsEigenschaftWhereInput>;
  some?: InputMaybe<OrtsEigenschaftWhereInput>;
};

export type OrtsEigenschaftOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type OrtsEigenschaftRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<OrtsEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtsEigenschaftCreateInput>>;
};

export type OrtsEigenschaftRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<OrtsEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<OrtsEigenschaftCreateInput>>;
  disconnect?: InputMaybe<Array<OrtsEigenschaftWhereUniqueInput>>;
  set?: InputMaybe<Array<OrtsEigenschaftWhereUniqueInput>>;
};

export type OrtsEigenschaftUpdateArgs = {
  data: OrtsEigenschaftUpdateInput;
  where: OrtsEigenschaftWhereUniqueInput;
};

export type OrtsEigenschaftUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  orte?: InputMaybe<OrtRelateToManyForUpdateInput>;
};

export type OrtsEigenschaftWhereInput = {
  AND?: InputMaybe<Array<OrtsEigenschaftWhereInput>>;
  NOT?: InputMaybe<Array<OrtsEigenschaftWhereInput>>;
  OR?: InputMaybe<Array<OrtsEigenschaftWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  orte?: InputMaybe<OrtManyRelationFilter>;
};

export type OrtsEigenschaftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean']['output'];
};

export type Person = {
  __typename?: 'Person';
  birthNameTaufbuch?: Maybe<Person_BirthNameTaufbuch_Document>;
  comuneTaufbuch?: Maybe<Gebiet>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dateOfBirth?: Maybe<Scalars['CalendarDay']['output']>;
  dateOfBirthSterbebuch?: Maybe<Scalars['CalendarDay']['output']>;
  dateOfBirthTaufbuch?: Maybe<Scalars['CalendarDay']['output']>;
  dateOfDeath?: Maybe<Scalars['CalendarDay']['output']>;
  dateOfDeathSterbebuch?: Maybe<Scalars['CalendarDay']['output']>;
  dateOfDeathTaufbuch?: Maybe<Scalars['CalendarDay']['output']>;
  description?: Maybe<Person_Description_Document>;
  displayName?: Maybe<Scalars['String']['output']>;
  eigenschaften?: Maybe<Array<PersonenEigenschaft>>;
  eigenschaftenCount?: Maybe<Scalars['Int']['output']>;
  eventCharacters?: Maybe<Array<Ereignis>>;
  eventCharactersCount?: Maybe<Scalars['Int']['output']>;
  eventDescriptionAuthor?: Maybe<Array<Ereignis>>;
  eventDescriptionAuthorCount?: Maybe<Scalars['Int']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  familyNameTaufbuch?: Maybe<Person_FamilyNameTaufbuch_Document>;
  father?: Maybe<Person>;
  fatherOf?: Maybe<Array<Person>>;
  fatherOfCount?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  groupCharacters?: Maybe<Array<Gruppe>>;
  groupCharactersCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Objekt>>;
  imagesCount?: Maybe<Scalars['Int']['output']>;
  importTimestamp?: Maybe<Scalars['String']['output']>;
  mother?: Maybe<Person>;
  motherOf?: Maybe<Array<Person>>;
  motherOfCount?: Maybe<Scalars['Int']['output']>;
  nickname?: Maybe<Person_Nickname_Document>;
  notes?: Maybe<Person_Notes_Document>;
  nrTaufbuch?: Maybe<Scalars['String']['output']>;
  objectAuthor?: Maybe<Array<Objekt>>;
  objectAuthorCount?: Maybe<Scalars['Int']['output']>;
  objectClient?: Maybe<Array<Objekt>>;
  objectClientCount?: Maybe<Scalars['Int']['output']>;
  objectDescriptionAuthor?: Maybe<Array<Objekt>>;
  objectDescriptionAuthorCount?: Maybe<Scalars['Int']['output']>;
  objectEditor?: Maybe<Array<Objekt>>;
  objectEditorCount?: Maybe<Scalars['Int']['output']>;
  objectOnWork?: Maybe<Array<Objekt>>;
  objectOnWorkCount?: Maybe<Scalars['Int']['output']>;
  occupation?: Maybe<Array<BerufsTyp>>;
  occupationCount?: Maybe<Scalars['Int']['output']>;
  onEvent?: Maybe<Array<Ereignis>>;
  onEventCount?: Maybe<Scalars['Int']['output']>;
  ownerOf?: Maybe<Array<Eigentum>>;
  ownerOfCount?: Maybe<Scalars['Int']['output']>;
  periodOfBirth?: Maybe<Entstehungszeit>;
  periodOfDeath?: Maybe<Entstehungszeit>;
  placeOfBirth?: Maybe<Ort>;
  placeOfBirthSterbebuch?: Maybe<Ort>;
  placeOfBirthTaufbuch?: Maybe<Ort>;
  placeOfDeath?: Maybe<Ort>;
  placeOfDeathSterbebuch?: Maybe<Ort>;
  placeOfDeathTaufbuch?: Maybe<Ort>;
  sex?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Person_Sources_Document>;
  sterbebuch?: Maybe<Kirchenbuch>;
  sterbebuchImg?: Maybe<KirchenbuchBild>;
  taufbuch?: Maybe<Array<Kirchenbuch>>;
  taufbuchCount?: Maybe<Scalars['Int']['output']>;
  taufbuchImg?: Maybe<Array<KirchenbuchBild>>;
  taufbuchImgCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  weblinks?: Maybe<Person_Weblinks_Document>;
  weddings?: Maybe<Array<Hochzeit>>;
  weddingsCount?: Maybe<Scalars['Int']['output']>;
  weddingsTaufbuch?: Maybe<Array<Hochzeit>>;
  weddingsTaufbuchCount?: Maybe<Scalars['Int']['output']>;
  zustaende?: Maybe<Array<Status>>;
  zustaendeCount?: Maybe<Scalars['Int']['output']>;
};


export type PersonEigenschaftenArgs = {
  cursor?: InputMaybe<PersonenEigenschaftWhereUniqueInput>;
  orderBy?: Array<PersonenEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonenEigenschaftWhereInput;
};


export type PersonEigenschaftenCountArgs = {
  where?: PersonenEigenschaftWhereInput;
};


export type PersonEventCharactersArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type PersonEventCharactersCountArgs = {
  where?: EreignisWhereInput;
};


export type PersonEventDescriptionAuthorArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type PersonEventDescriptionAuthorCountArgs = {
  where?: EreignisWhereInput;
};


export type PersonFatherOfArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type PersonFatherOfCountArgs = {
  where?: PersonWhereInput;
};


export type PersonGroupCharactersArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type PersonGroupCharactersCountArgs = {
  where?: GruppeWhereInput;
};


export type PersonImagesArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonImagesCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonMotherOfArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type PersonMotherOfCountArgs = {
  where?: PersonWhereInput;
};


export type PersonObjectAuthorArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonObjectAuthorCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonObjectClientArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonObjectClientCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonObjectDescriptionAuthorArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonObjectDescriptionAuthorCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonObjectEditorArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonObjectEditorCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonObjectOnWorkArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type PersonObjectOnWorkCountArgs = {
  where?: ObjektWhereInput;
};


export type PersonOccupationArgs = {
  cursor?: InputMaybe<BerufsTypWhereUniqueInput>;
  orderBy?: Array<BerufsTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BerufsTypWhereInput;
};


export type PersonOccupationCountArgs = {
  where?: BerufsTypWhereInput;
};


export type PersonOnEventArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type PersonOnEventCountArgs = {
  where?: EreignisWhereInput;
};


export type PersonOwnerOfArgs = {
  cursor?: InputMaybe<EigentumWhereUniqueInput>;
  orderBy?: Array<EigentumOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EigentumWhereInput;
};


export type PersonOwnerOfCountArgs = {
  where?: EigentumWhereInput;
};


export type PersonTaufbuchArgs = {
  cursor?: InputMaybe<KirchenbuchWhereUniqueInput>;
  orderBy?: Array<KirchenbuchOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchWhereInput;
};


export type PersonTaufbuchCountArgs = {
  where?: KirchenbuchWhereInput;
};


export type PersonTaufbuchImgArgs = {
  cursor?: InputMaybe<KirchenbuchBildWhereUniqueInput>;
  orderBy?: Array<KirchenbuchBildOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchBildWhereInput;
};


export type PersonTaufbuchImgCountArgs = {
  where?: KirchenbuchBildWhereInput;
};


export type PersonWeddingsArgs = {
  cursor?: InputMaybe<HochzeitWhereUniqueInput>;
  orderBy?: Array<HochzeitOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: HochzeitWhereInput;
};


export type PersonWeddingsCountArgs = {
  where?: HochzeitWhereInput;
};


export type PersonWeddingsTaufbuchArgs = {
  cursor?: InputMaybe<HochzeitWhereUniqueInput>;
  orderBy?: Array<HochzeitOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: HochzeitWhereInput;
};


export type PersonWeddingsTaufbuchCountArgs = {
  where?: HochzeitWhereInput;
};


export type PersonZustaendeArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type PersonZustaendeCountArgs = {
  where?: StatusWhereInput;
};

export type PersonCreateInput = {
  birthNameTaufbuch?: InputMaybe<Scalars['JSON']['input']>;
  comuneTaufbuch?: InputMaybe<GebietRelateToOneForCreateInput>;
  dateOfBirth?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfBirthSterbebuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfBirthTaufbuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeath?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeathSterbebuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeathTaufbuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<PersonenEigenschaftRelateToManyForCreateInput>;
  eventCharacters?: InputMaybe<EreignisRelateToManyForCreateInput>;
  eventDescriptionAuthor?: InputMaybe<EreignisRelateToManyForCreateInput>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  familyNameTaufbuch?: InputMaybe<Scalars['JSON']['input']>;
  father?: InputMaybe<PersonRelateToOneForCreateInput>;
  fatherOf?: InputMaybe<PersonRelateToManyForCreateInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  groupCharacters?: InputMaybe<GruppeRelateToManyForCreateInput>;
  images?: InputMaybe<ObjektRelateToManyForCreateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  mother?: InputMaybe<PersonRelateToOneForCreateInput>;
  motherOf?: InputMaybe<PersonRelateToManyForCreateInput>;
  nickname?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  nrTaufbuch?: InputMaybe<Scalars['String']['input']>;
  objectAuthor?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectClient?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectDescriptionAuthor?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectEditor?: InputMaybe<ObjektRelateToManyForCreateInput>;
  objectOnWork?: InputMaybe<ObjektRelateToManyForCreateInput>;
  occupation?: InputMaybe<BerufsTypRelateToManyForCreateInput>;
  onEvent?: InputMaybe<EreignisRelateToManyForCreateInput>;
  ownerOf?: InputMaybe<EigentumRelateToManyForCreateInput>;
  periodOfBirth?: InputMaybe<EntstehungszeitRelateToOneForCreateInput>;
  periodOfDeath?: InputMaybe<EntstehungszeitRelateToOneForCreateInput>;
  placeOfBirth?: InputMaybe<OrtRelateToOneForCreateInput>;
  placeOfBirthSterbebuch?: InputMaybe<OrtRelateToOneForCreateInput>;
  placeOfBirthTaufbuch?: InputMaybe<OrtRelateToOneForCreateInput>;
  placeOfDeath?: InputMaybe<OrtRelateToOneForCreateInput>;
  placeOfDeathSterbebuch?: InputMaybe<OrtRelateToOneForCreateInput>;
  placeOfDeathTaufbuch?: InputMaybe<OrtRelateToOneForCreateInput>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  sterbebuch?: InputMaybe<KirchenbuchRelateToOneForCreateInput>;
  sterbebuchImg?: InputMaybe<KirchenbuchBildRelateToOneForCreateInput>;
  taufbuch?: InputMaybe<KirchenbuchRelateToManyForCreateInput>;
  taufbuchImg?: InputMaybe<KirchenbuchBildRelateToManyForCreateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  weddings?: InputMaybe<HochzeitRelateToManyForCreateInput>;
  weddingsTaufbuch?: InputMaybe<HochzeitRelateToManyForCreateInput>;
  zustaende?: InputMaybe<StatusRelateToManyForCreateInput>;
};

export type PersonManyRelationFilter = {
  every?: InputMaybe<PersonWhereInput>;
  none?: InputMaybe<PersonWhereInput>;
  some?: InputMaybe<PersonWhereInput>;
};

export type PersonOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  dateOfBirth?: InputMaybe<OrderDirection>;
  dateOfBirthSterbebuch?: InputMaybe<OrderDirection>;
  dateOfBirthTaufbuch?: InputMaybe<OrderDirection>;
  dateOfDeath?: InputMaybe<OrderDirection>;
  dateOfDeathSterbebuch?: InputMaybe<OrderDirection>;
  dateOfDeathTaufbuch?: InputMaybe<OrderDirection>;
  familyName?: InputMaybe<OrderDirection>;
  fullName?: InputMaybe<OrderDirection>;
  givenName?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  importTimestamp?: InputMaybe<OrderDirection>;
  nrTaufbuch?: InputMaybe<OrderDirection>;
  sex?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type PersonRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  create?: InputMaybe<Array<PersonCreateInput>>;
};

export type PersonRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  create?: InputMaybe<Array<PersonCreateInput>>;
  disconnect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  set?: InputMaybe<Array<PersonWhereUniqueInput>>;
};

export type PersonRelateToOneForCreateInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  create?: InputMaybe<PersonCreateInput>;
};

export type PersonRelateToOneForUpdateInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  create?: InputMaybe<PersonCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonUpdateArgs = {
  data: PersonUpdateInput;
  where: PersonWhereUniqueInput;
};

export type PersonUpdateInput = {
  birthNameTaufbuch?: InputMaybe<Scalars['JSON']['input']>;
  comuneTaufbuch?: InputMaybe<GebietRelateToOneForUpdateInput>;
  dateOfBirth?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfBirthSterbebuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfBirthTaufbuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeath?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeathSterbebuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  dateOfDeathTaufbuch?: InputMaybe<Scalars['CalendarDay']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  eigenschaften?: InputMaybe<PersonenEigenschaftRelateToManyForUpdateInput>;
  eventCharacters?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  eventDescriptionAuthor?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  familyNameTaufbuch?: InputMaybe<Scalars['JSON']['input']>;
  father?: InputMaybe<PersonRelateToOneForUpdateInput>;
  fatherOf?: InputMaybe<PersonRelateToManyForUpdateInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  groupCharacters?: InputMaybe<GruppeRelateToManyForUpdateInput>;
  images?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  importTimestamp?: InputMaybe<Scalars['String']['input']>;
  mother?: InputMaybe<PersonRelateToOneForUpdateInput>;
  motherOf?: InputMaybe<PersonRelateToManyForUpdateInput>;
  nickname?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  nrTaufbuch?: InputMaybe<Scalars['String']['input']>;
  objectAuthor?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectClient?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectDescriptionAuthor?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectEditor?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  objectOnWork?: InputMaybe<ObjektRelateToManyForUpdateInput>;
  occupation?: InputMaybe<BerufsTypRelateToManyForUpdateInput>;
  onEvent?: InputMaybe<EreignisRelateToManyForUpdateInput>;
  ownerOf?: InputMaybe<EigentumRelateToManyForUpdateInput>;
  periodOfBirth?: InputMaybe<EntstehungszeitRelateToOneForUpdateInput>;
  periodOfDeath?: InputMaybe<EntstehungszeitRelateToOneForUpdateInput>;
  placeOfBirth?: InputMaybe<OrtRelateToOneForUpdateInput>;
  placeOfBirthSterbebuch?: InputMaybe<OrtRelateToOneForUpdateInput>;
  placeOfBirthTaufbuch?: InputMaybe<OrtRelateToOneForUpdateInput>;
  placeOfDeath?: InputMaybe<OrtRelateToOneForUpdateInput>;
  placeOfDeathSterbebuch?: InputMaybe<OrtRelateToOneForUpdateInput>;
  placeOfDeathTaufbuch?: InputMaybe<OrtRelateToOneForUpdateInput>;
  sex?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  sterbebuch?: InputMaybe<KirchenbuchRelateToOneForUpdateInput>;
  sterbebuchImg?: InputMaybe<KirchenbuchBildRelateToOneForUpdateInput>;
  taufbuch?: InputMaybe<KirchenbuchRelateToManyForUpdateInput>;
  taufbuchImg?: InputMaybe<KirchenbuchBildRelateToManyForUpdateInput>;
  weblinks?: InputMaybe<Scalars['JSON']['input']>;
  weddings?: InputMaybe<HochzeitRelateToManyForUpdateInput>;
  weddingsTaufbuch?: InputMaybe<HochzeitRelateToManyForUpdateInput>;
  zustaende?: InputMaybe<StatusRelateToManyForUpdateInput>;
};

export type PersonWhereInput = {
  AND?: InputMaybe<Array<PersonWhereInput>>;
  NOT?: InputMaybe<Array<PersonWhereInput>>;
  OR?: InputMaybe<Array<PersonWhereInput>>;
  comuneTaufbuch?: InputMaybe<GebietWhereInput>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  dateOfBirth?: InputMaybe<CalendarDayNullableFilter>;
  dateOfBirthSterbebuch?: InputMaybe<CalendarDayNullableFilter>;
  dateOfBirthTaufbuch?: InputMaybe<CalendarDayNullableFilter>;
  dateOfDeath?: InputMaybe<CalendarDayNullableFilter>;
  dateOfDeathSterbebuch?: InputMaybe<CalendarDayNullableFilter>;
  dateOfDeathTaufbuch?: InputMaybe<CalendarDayNullableFilter>;
  eigenschaften?: InputMaybe<PersonenEigenschaftManyRelationFilter>;
  eventCharacters?: InputMaybe<EreignisManyRelationFilter>;
  eventDescriptionAuthor?: InputMaybe<EreignisManyRelationFilter>;
  familyName?: InputMaybe<StringFilter>;
  father?: InputMaybe<PersonWhereInput>;
  fatherOf?: InputMaybe<PersonManyRelationFilter>;
  fullName?: InputMaybe<StringFilter>;
  givenName?: InputMaybe<StringFilter>;
  groupCharacters?: InputMaybe<GruppeManyRelationFilter>;
  id?: InputMaybe<IdFilter>;
  images?: InputMaybe<ObjektManyRelationFilter>;
  importTimestamp?: InputMaybe<StringFilter>;
  mother?: InputMaybe<PersonWhereInput>;
  motherOf?: InputMaybe<PersonManyRelationFilter>;
  nrTaufbuch?: InputMaybe<StringFilter>;
  objectAuthor?: InputMaybe<ObjektManyRelationFilter>;
  objectClient?: InputMaybe<ObjektManyRelationFilter>;
  objectDescriptionAuthor?: InputMaybe<ObjektManyRelationFilter>;
  objectEditor?: InputMaybe<ObjektManyRelationFilter>;
  objectOnWork?: InputMaybe<ObjektManyRelationFilter>;
  occupation?: InputMaybe<BerufsTypManyRelationFilter>;
  onEvent?: InputMaybe<EreignisManyRelationFilter>;
  ownerOf?: InputMaybe<EigentumManyRelationFilter>;
  periodOfBirth?: InputMaybe<EntstehungszeitWhereInput>;
  periodOfDeath?: InputMaybe<EntstehungszeitWhereInput>;
  placeOfBirth?: InputMaybe<OrtWhereInput>;
  placeOfBirthSterbebuch?: InputMaybe<OrtWhereInput>;
  placeOfBirthTaufbuch?: InputMaybe<OrtWhereInput>;
  placeOfDeath?: InputMaybe<OrtWhereInput>;
  placeOfDeathSterbebuch?: InputMaybe<OrtWhereInput>;
  placeOfDeathTaufbuch?: InputMaybe<OrtWhereInput>;
  sex?: InputMaybe<StringNullableFilter>;
  sterbebuch?: InputMaybe<KirchenbuchWhereInput>;
  sterbebuchImg?: InputMaybe<KirchenbuchBildWhereInput>;
  taufbuch?: InputMaybe<KirchenbuchManyRelationFilter>;
  taufbuchImg?: InputMaybe<KirchenbuchBildManyRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  weddings?: InputMaybe<HochzeitManyRelationFilter>;
  weddingsTaufbuch?: InputMaybe<HochzeitManyRelationFilter>;
  zustaende?: InputMaybe<StatusManyRelationFilter>;
};

export type PersonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Person_BirthNameTaufbuch_Document = {
  __typename?: 'Person_birthNameTaufbuch_Document';
  document: Scalars['JSON']['output'];
};


export type Person_BirthNameTaufbuch_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_Description_Document = {
  __typename?: 'Person_description_Document';
  document: Scalars['JSON']['output'];
};


export type Person_Description_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_FamilyNameTaufbuch_Document = {
  __typename?: 'Person_familyNameTaufbuch_Document';
  document: Scalars['JSON']['output'];
};


export type Person_FamilyNameTaufbuch_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_Nickname_Document = {
  __typename?: 'Person_nickname_Document';
  document: Scalars['JSON']['output'];
};


export type Person_Nickname_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_Notes_Document = {
  __typename?: 'Person_notes_Document';
  document: Scalars['JSON']['output'];
};


export type Person_Notes_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_Sources_Document = {
  __typename?: 'Person_sources_Document';
  document: Scalars['JSON']['output'];
};


export type Person_Sources_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type Person_Weblinks_Document = {
  __typename?: 'Person_weblinks_Document';
  document: Scalars['JSON']['output'];
};


export type Person_Weblinks_DocumentDocumentArgs = {
  hydrateRelationships?: Scalars['Boolean']['input'];
};

export type PersonenEigenschaft = {
  __typename?: 'PersonenEigenschaft';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personen?: Maybe<Array<Person>>;
  personenCount?: Maybe<Scalars['Int']['output']>;
};


export type PersonenEigenschaftPersonenArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type PersonenEigenschaftPersonenCountArgs = {
  where?: PersonWhereInput;
};

export type PersonenEigenschaftCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personen?: InputMaybe<PersonRelateToManyForCreateInput>;
};

export type PersonenEigenschaftManyRelationFilter = {
  every?: InputMaybe<PersonenEigenschaftWhereInput>;
  none?: InputMaybe<PersonenEigenschaftWhereInput>;
  some?: InputMaybe<PersonenEigenschaftWhereInput>;
};

export type PersonenEigenschaftOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type PersonenEigenschaftRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PersonenEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<PersonenEigenschaftCreateInput>>;
};

export type PersonenEigenschaftRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PersonenEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<PersonenEigenschaftCreateInput>>;
  disconnect?: InputMaybe<Array<PersonenEigenschaftWhereUniqueInput>>;
  set?: InputMaybe<Array<PersonenEigenschaftWhereUniqueInput>>;
};

export type PersonenEigenschaftUpdateArgs = {
  data: PersonenEigenschaftUpdateInput;
  where: PersonenEigenschaftWhereUniqueInput;
};

export type PersonenEigenschaftUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  personen?: InputMaybe<PersonRelateToManyForUpdateInput>;
};

export type PersonenEigenschaftWhereInput = {
  AND?: InputMaybe<Array<PersonenEigenschaftWhereInput>>;
  NOT?: InputMaybe<Array<PersonenEigenschaftWhereInput>>;
  OR?: InputMaybe<Array<PersonenEigenschaftWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  personen?: InputMaybe<PersonManyRelationFilter>;
};

export type PersonenEigenschaftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Query = {
  __typename?: 'Query';
  authenticatedItem?: Maybe<AuthenticatedItem>;
  berufsTyp?: Maybe<BerufsTyp>;
  berufsTyps?: Maybe<Array<BerufsTyp>>;
  berufsTypsCount?: Maybe<Scalars['Int']['output']>;
  copyrightTyp?: Maybe<CopyrightTyp>;
  copyrightTyps?: Maybe<Array<CopyrightTyp>>;
  copyrightTypsCount?: Maybe<Scalars['Int']['output']>;
  eigentum?: Maybe<Eigentum>;
  eigentums?: Maybe<Array<Eigentum>>;
  eigentumsCount?: Maybe<Scalars['Int']['output']>;
  entstehungszeit?: Maybe<Entstehungszeit>;
  entstehungszeits?: Maybe<Array<Entstehungszeit>>;
  entstehungszeitsCount?: Maybe<Scalars['Int']['output']>;
  ereignis?: Maybe<Ereignis>;
  ereignisEigenschaft?: Maybe<EreignisEigenschaft>;
  ereignisEigenschafts?: Maybe<Array<EreignisEigenschaft>>;
  ereignisEigenschaftsCount?: Maybe<Scalars['Int']['output']>;
  ereignisTyp?: Maybe<EreignisTyp>;
  ereignisTyps?: Maybe<Array<EreignisTyp>>;
  ereignisTypsCount?: Maybe<Scalars['Int']['output']>;
  ereignisse?: Maybe<Array<Ereignis>>;
  ereignisseCount?: Maybe<Scalars['Int']['output']>;
  foto?: Maybe<Foto>;
  fotos?: Maybe<Array<Foto>>;
  fotosCount?: Maybe<Scalars['Int']['output']>;
  gebiet?: Maybe<Gebiet>;
  gebiets?: Maybe<Array<Gebiet>>;
  gebietsCount?: Maybe<Scalars['Int']['output']>;
  gebietsTyp?: Maybe<GebietsTyp>;
  gebietsTyps?: Maybe<Array<GebietsTyp>>;
  gebietsTypsCount?: Maybe<Scalars['Int']['output']>;
  gruppe?: Maybe<Gruppe>;
  gruppenEigenschaft?: Maybe<GruppenEigenschaft>;
  gruppenEigenschafts?: Maybe<Array<GruppenEigenschaft>>;
  gruppenEigenschaftsCount?: Maybe<Scalars['Int']['output']>;
  gruppenTyp?: Maybe<GruppenTyp>;
  gruppenTyps?: Maybe<Array<GruppenTyp>>;
  gruppenTypsCount?: Maybe<Scalars['Int']['output']>;
  gruppes?: Maybe<Array<Gruppe>>;
  gruppesCount?: Maybe<Scalars['Int']['output']>;
  hochzeit?: Maybe<Hochzeit>;
  hochzeits?: Maybe<Array<Hochzeit>>;
  hochzeitsCount?: Maybe<Scalars['Int']['output']>;
  keystone: KeystoneMeta;
  kirchenbuch?: Maybe<Kirchenbuch>;
  kirchenbuchBild?: Maybe<KirchenbuchBild>;
  kirchenbuchBilds?: Maybe<Array<KirchenbuchBild>>;
  kirchenbuchBildsCount?: Maybe<Scalars['Int']['output']>;
  kirchenbuchTyp?: Maybe<KirchenbuchTyp>;
  kirchenbuchTyps?: Maybe<Array<KirchenbuchTyp>>;
  kirchenbuchTypsCount?: Maybe<Scalars['Int']['output']>;
  kirchenbuches?: Maybe<Array<Kirchenbuch>>;
  kirchenbuchesCount?: Maybe<Scalars['Int']['output']>;
  objekt?: Maybe<Objekt>;
  objektEigenschaftFoto?: Maybe<ObjektEigenschaftFoto>;
  objektEigenschaftFotos?: Maybe<Array<ObjektEigenschaftFoto>>;
  objektEigenschaftFotosCount?: Maybe<Scalars['Int']['output']>;
  objektEigenschaftMaterial?: Maybe<ObjektEigenschaftMaterial>;
  objektEigenschaftMaterials?: Maybe<Array<ObjektEigenschaftMaterial>>;
  objektEigenschaftMaterialsCount?: Maybe<Scalars['Int']['output']>;
  objektEigenschaftPublikation?: Maybe<ObjektEigenschaftPublikation>;
  objektEigenschaftPublikations?: Maybe<Array<ObjektEigenschaftPublikation>>;
  objektEigenschaftPublikationsCount?: Maybe<Scalars['Int']['output']>;
  objektEigenschaftTechnik?: Maybe<ObjektEigenschaftTechnik>;
  objektEigenschaftTechniks?: Maybe<Array<ObjektEigenschaftTechnik>>;
  objektEigenschaftTechniksCount?: Maybe<Scalars['Int']['output']>;
  objektEigenschaftVolkskunde?: Maybe<ObjektEigenschaftVolkskunde>;
  objektEigenschaftVolkskundes?: Maybe<Array<ObjektEigenschaftVolkskunde>>;
  objektEigenschaftVolkskundesCount?: Maybe<Scalars['Int']['output']>;
  objektTyp?: Maybe<ObjektTyp>;
  objektTyps?: Maybe<Array<ObjektTyp>>;
  objektTypsCount?: Maybe<Scalars['Int']['output']>;
  objekts?: Maybe<Array<Objekt>>;
  objektsCount?: Maybe<Scalars['Int']['output']>;
  ort?: Maybe<Ort>;
  ortTyp?: Maybe<OrtTyp>;
  ortTyps?: Maybe<Array<OrtTyp>>;
  ortTypsCount?: Maybe<Scalars['Int']['output']>;
  orts?: Maybe<Array<Ort>>;
  ortsCount?: Maybe<Scalars['Int']['output']>;
  ortsEigenschaft?: Maybe<OrtsEigenschaft>;
  ortsEigenschafts?: Maybe<Array<OrtsEigenschaft>>;
  ortsEigenschaftsCount?: Maybe<Scalars['Int']['output']>;
  people?: Maybe<Array<Person>>;
  peopleCount?: Maybe<Scalars['Int']['output']>;
  person?: Maybe<Person>;
  personenEigenschaft?: Maybe<PersonenEigenschaft>;
  personenEigenschafts?: Maybe<Array<PersonenEigenschaft>>;
  personenEigenschaftsCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Status>;
  statuses?: Maybe<Array<Status>>;
  statusesCount?: Maybe<Scalars['Int']['output']>;
  sterbebildEigenschaft?: Maybe<SterbebildEigenschaft>;
  sterbebildEigenschafts?: Maybe<Array<SterbebildEigenschaft>>;
  sterbebildEigenschaftsCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  zeitspanne?: Maybe<Zeitspanne>;
  zeitspannes?: Maybe<Array<Zeitspanne>>;
  zeitspannesCount?: Maybe<Scalars['Int']['output']>;
};


export type QueryBerufsTypArgs = {
  where: BerufsTypWhereUniqueInput;
};


export type QueryBerufsTypsArgs = {
  cursor?: InputMaybe<BerufsTypWhereUniqueInput>;
  orderBy?: Array<BerufsTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BerufsTypWhereInput;
};


export type QueryBerufsTypsCountArgs = {
  where?: BerufsTypWhereInput;
};


export type QueryCopyrightTypArgs = {
  where: CopyrightTypWhereUniqueInput;
};


export type QueryCopyrightTypsArgs = {
  cursor?: InputMaybe<CopyrightTypWhereUniqueInput>;
  orderBy?: Array<CopyrightTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CopyrightTypWhereInput;
};


export type QueryCopyrightTypsCountArgs = {
  where?: CopyrightTypWhereInput;
};


export type QueryEigentumArgs = {
  where: EigentumWhereUniqueInput;
};


export type QueryEigentumsArgs = {
  cursor?: InputMaybe<EigentumWhereUniqueInput>;
  orderBy?: Array<EigentumOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EigentumWhereInput;
};


export type QueryEigentumsCountArgs = {
  where?: EigentumWhereInput;
};


export type QueryEntstehungszeitArgs = {
  where: EntstehungszeitWhereUniqueInput;
};


export type QueryEntstehungszeitsArgs = {
  cursor?: InputMaybe<EntstehungszeitWhereUniqueInput>;
  orderBy?: Array<EntstehungszeitOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EntstehungszeitWhereInput;
};


export type QueryEntstehungszeitsCountArgs = {
  where?: EntstehungszeitWhereInput;
};


export type QueryEreignisArgs = {
  where: EreignisWhereUniqueInput;
};


export type QueryEreignisEigenschaftArgs = {
  where: EreignisEigenschaftWhereUniqueInput;
};


export type QueryEreignisEigenschaftsArgs = {
  cursor?: InputMaybe<EreignisEigenschaftWhereUniqueInput>;
  orderBy?: Array<EreignisEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisEigenschaftWhereInput;
};


export type QueryEreignisEigenschaftsCountArgs = {
  where?: EreignisEigenschaftWhereInput;
};


export type QueryEreignisTypArgs = {
  where: EreignisTypWhereUniqueInput;
};


export type QueryEreignisTypsArgs = {
  cursor?: InputMaybe<EreignisTypWhereUniqueInput>;
  orderBy?: Array<EreignisTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisTypWhereInput;
};


export type QueryEreignisTypsCountArgs = {
  where?: EreignisTypWhereInput;
};


export type QueryEreignisseArgs = {
  cursor?: InputMaybe<EreignisWhereUniqueInput>;
  orderBy?: Array<EreignisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EreignisWhereInput;
};


export type QueryEreignisseCountArgs = {
  where?: EreignisWhereInput;
};


export type QueryFotoArgs = {
  where: FotoWhereUniqueInput;
};


export type QueryFotosArgs = {
  cursor?: InputMaybe<FotoWhereUniqueInput>;
  orderBy?: Array<FotoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: FotoWhereInput;
};


export type QueryFotosCountArgs = {
  where?: FotoWhereInput;
};


export type QueryGebietArgs = {
  where: GebietWhereUniqueInput;
};


export type QueryGebietsArgs = {
  cursor?: InputMaybe<GebietWhereUniqueInput>;
  orderBy?: Array<GebietOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GebietWhereInput;
};


export type QueryGebietsCountArgs = {
  where?: GebietWhereInput;
};


export type QueryGebietsTypArgs = {
  where: GebietsTypWhereUniqueInput;
};


export type QueryGebietsTypsArgs = {
  cursor?: InputMaybe<GebietsTypWhereUniqueInput>;
  orderBy?: Array<GebietsTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GebietsTypWhereInput;
};


export type QueryGebietsTypsCountArgs = {
  where?: GebietsTypWhereInput;
};


export type QueryGruppeArgs = {
  where: GruppeWhereUniqueInput;
};


export type QueryGruppenEigenschaftArgs = {
  where: GruppenEigenschaftWhereUniqueInput;
};


export type QueryGruppenEigenschaftsArgs = {
  cursor?: InputMaybe<GruppenEigenschaftWhereUniqueInput>;
  orderBy?: Array<GruppenEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppenEigenschaftWhereInput;
};


export type QueryGruppenEigenschaftsCountArgs = {
  where?: GruppenEigenschaftWhereInput;
};


export type QueryGruppenTypArgs = {
  where: GruppenTypWhereUniqueInput;
};


export type QueryGruppenTypsArgs = {
  cursor?: InputMaybe<GruppenTypWhereUniqueInput>;
  orderBy?: Array<GruppenTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppenTypWhereInput;
};


export type QueryGruppenTypsCountArgs = {
  where?: GruppenTypWhereInput;
};


export type QueryGruppesArgs = {
  cursor?: InputMaybe<GruppeWhereUniqueInput>;
  orderBy?: Array<GruppeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: GruppeWhereInput;
};


export type QueryGruppesCountArgs = {
  where?: GruppeWhereInput;
};


export type QueryHochzeitArgs = {
  where: HochzeitWhereUniqueInput;
};


export type QueryHochzeitsArgs = {
  cursor?: InputMaybe<HochzeitWhereUniqueInput>;
  orderBy?: Array<HochzeitOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: HochzeitWhereInput;
};


export type QueryHochzeitsCountArgs = {
  where?: HochzeitWhereInput;
};


export type QueryKirchenbuchArgs = {
  where: KirchenbuchWhereUniqueInput;
};


export type QueryKirchenbuchBildArgs = {
  where: KirchenbuchBildWhereUniqueInput;
};


export type QueryKirchenbuchBildsArgs = {
  cursor?: InputMaybe<KirchenbuchBildWhereUniqueInput>;
  orderBy?: Array<KirchenbuchBildOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchBildWhereInput;
};


export type QueryKirchenbuchBildsCountArgs = {
  where?: KirchenbuchBildWhereInput;
};


export type QueryKirchenbuchTypArgs = {
  where: KirchenbuchTypWhereUniqueInput;
};


export type QueryKirchenbuchTypsArgs = {
  cursor?: InputMaybe<KirchenbuchTypWhereUniqueInput>;
  orderBy?: Array<KirchenbuchTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchTypWhereInput;
};


export type QueryKirchenbuchTypsCountArgs = {
  where?: KirchenbuchTypWhereInput;
};


export type QueryKirchenbuchesArgs = {
  cursor?: InputMaybe<KirchenbuchWhereUniqueInput>;
  orderBy?: Array<KirchenbuchOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: KirchenbuchWhereInput;
};


export type QueryKirchenbuchesCountArgs = {
  where?: KirchenbuchWhereInput;
};


export type QueryObjektArgs = {
  where: ObjektWhereUniqueInput;
};


export type QueryObjektEigenschaftFotoArgs = {
  where: ObjektEigenschaftFotoWhereUniqueInput;
};


export type QueryObjektEigenschaftFotosArgs = {
  cursor?: InputMaybe<ObjektEigenschaftFotoWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftFotoOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftFotoWhereInput;
};


export type QueryObjektEigenschaftFotosCountArgs = {
  where?: ObjektEigenschaftFotoWhereInput;
};


export type QueryObjektEigenschaftMaterialArgs = {
  where: ObjektEigenschaftMaterialWhereUniqueInput;
};


export type QueryObjektEigenschaftMaterialsArgs = {
  cursor?: InputMaybe<ObjektEigenschaftMaterialWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftMaterialOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftMaterialWhereInput;
};


export type QueryObjektEigenschaftMaterialsCountArgs = {
  where?: ObjektEigenschaftMaterialWhereInput;
};


export type QueryObjektEigenschaftPublikationArgs = {
  where: ObjektEigenschaftPublikationWhereUniqueInput;
};


export type QueryObjektEigenschaftPublikationsArgs = {
  cursor?: InputMaybe<ObjektEigenschaftPublikationWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftPublikationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftPublikationWhereInput;
};


export type QueryObjektEigenschaftPublikationsCountArgs = {
  where?: ObjektEigenschaftPublikationWhereInput;
};


export type QueryObjektEigenschaftTechnikArgs = {
  where: ObjektEigenschaftTechnikWhereUniqueInput;
};


export type QueryObjektEigenschaftTechniksArgs = {
  cursor?: InputMaybe<ObjektEigenschaftTechnikWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftTechnikOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftTechnikWhereInput;
};


export type QueryObjektEigenschaftTechniksCountArgs = {
  where?: ObjektEigenschaftTechnikWhereInput;
};


export type QueryObjektEigenschaftVolkskundeArgs = {
  where: ObjektEigenschaftVolkskundeWhereUniqueInput;
};


export type QueryObjektEigenschaftVolkskundesArgs = {
  cursor?: InputMaybe<ObjektEigenschaftVolkskundeWhereUniqueInput>;
  orderBy?: Array<ObjektEigenschaftVolkskundeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektEigenschaftVolkskundeWhereInput;
};


export type QueryObjektEigenschaftVolkskundesCountArgs = {
  where?: ObjektEigenschaftVolkskundeWhereInput;
};


export type QueryObjektTypArgs = {
  where: ObjektTypWhereUniqueInput;
};


export type QueryObjektTypsArgs = {
  cursor?: InputMaybe<ObjektTypWhereUniqueInput>;
  orderBy?: Array<ObjektTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektTypWhereInput;
};


export type QueryObjektTypsCountArgs = {
  where?: ObjektTypWhereInput;
};


export type QueryObjektsArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type QueryObjektsCountArgs = {
  where?: ObjektWhereInput;
};


export type QueryOrtArgs = {
  where: OrtWhereUniqueInput;
};


export type QueryOrtTypArgs = {
  where: OrtTypWhereUniqueInput;
};


export type QueryOrtTypsArgs = {
  cursor?: InputMaybe<OrtTypWhereUniqueInput>;
  orderBy?: Array<OrtTypOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtTypWhereInput;
};


export type QueryOrtTypsCountArgs = {
  where?: OrtTypWhereInput;
};


export type QueryOrtsArgs = {
  cursor?: InputMaybe<OrtWhereUniqueInput>;
  orderBy?: Array<OrtOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtWhereInput;
};


export type QueryOrtsCountArgs = {
  where?: OrtWhereInput;
};


export type QueryOrtsEigenschaftArgs = {
  where: OrtsEigenschaftWhereUniqueInput;
};


export type QueryOrtsEigenschaftsArgs = {
  cursor?: InputMaybe<OrtsEigenschaftWhereUniqueInput>;
  orderBy?: Array<OrtsEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: OrtsEigenschaftWhereInput;
};


export type QueryOrtsEigenschaftsCountArgs = {
  where?: OrtsEigenschaftWhereInput;
};


export type QueryPeopleArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  orderBy?: Array<PersonOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonWhereInput;
};


export type QueryPeopleCountArgs = {
  where?: PersonWhereInput;
};


export type QueryPersonArgs = {
  where: PersonWhereUniqueInput;
};


export type QueryPersonenEigenschaftArgs = {
  where: PersonenEigenschaftWhereUniqueInput;
};


export type QueryPersonenEigenschaftsArgs = {
  cursor?: InputMaybe<PersonenEigenschaftWhereUniqueInput>;
  orderBy?: Array<PersonenEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PersonenEigenschaftWhereInput;
};


export type QueryPersonenEigenschaftsCountArgs = {
  where?: PersonenEigenschaftWhereInput;
};


export type QueryStatusArgs = {
  where: StatusWhereUniqueInput;
};


export type QueryStatusesArgs = {
  cursor?: InputMaybe<StatusWhereUniqueInput>;
  orderBy?: Array<StatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: StatusWhereInput;
};


export type QueryStatusesCountArgs = {
  where?: StatusWhereInput;
};


export type QuerySterbebildEigenschaftArgs = {
  where: SterbebildEigenschaftWhereUniqueInput;
};


export type QuerySterbebildEigenschaftsArgs = {
  cursor?: InputMaybe<SterbebildEigenschaftWhereUniqueInput>;
  orderBy?: Array<SterbebildEigenschaftOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SterbebildEigenschaftWhereInput;
};


export type QuerySterbebildEigenschaftsCountArgs = {
  where?: SterbebildEigenschaftWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryZeitspanneArgs = {
  where: ZeitspanneWhereUniqueInput;
};


export type QueryZeitspannesArgs = {
  cursor?: InputMaybe<ZeitspanneWhereUniqueInput>;
  orderBy?: Array<ZeitspanneOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ZeitspanneWhereInput;
};


export type QueryZeitspannesCountArgs = {
  where?: ZeitspanneWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Status = {
  __typename?: 'Status';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type StatusCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StatusManyRelationFilter = {
  every?: InputMaybe<StatusWhereInput>;
  none?: InputMaybe<StatusWhereInput>;
  some?: InputMaybe<StatusWhereInput>;
};

export type StatusOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type StatusRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<StatusWhereUniqueInput>>;
  create?: InputMaybe<Array<StatusCreateInput>>;
};

export type StatusRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<StatusWhereUniqueInput>>;
  create?: InputMaybe<Array<StatusCreateInput>>;
  disconnect?: InputMaybe<Array<StatusWhereUniqueInput>>;
  set?: InputMaybe<Array<StatusWhereUniqueInput>>;
};

export type StatusUpdateArgs = {
  data: StatusUpdateInput;
  where: StatusWhereUniqueInput;
};

export type StatusUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StatusWhereInput = {
  AND?: InputMaybe<Array<StatusWhereInput>>;
  NOT?: InputMaybe<Array<StatusWhereInput>>;
  OR?: InputMaybe<Array<StatusWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SterbebildEigenschaft = {
  __typename?: 'SterbebildEigenschaft';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  objekte?: Maybe<Array<Objekt>>;
  objekteCount?: Maybe<Scalars['Int']['output']>;
};


export type SterbebildEigenschaftObjekteArgs = {
  cursor?: InputMaybe<ObjektWhereUniqueInput>;
  orderBy?: Array<ObjektOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObjektWhereInput;
};


export type SterbebildEigenschaftObjekteCountArgs = {
  where?: ObjektWhereInput;
};

export type SterbebildEigenschaftCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForCreateInput>;
};

export type SterbebildEigenschaftManyRelationFilter = {
  every?: InputMaybe<SterbebildEigenschaftWhereInput>;
  none?: InputMaybe<SterbebildEigenschaftWhereInput>;
  some?: InputMaybe<SterbebildEigenschaftWhereInput>;
};

export type SterbebildEigenschaftOrderByInput = {
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type SterbebildEigenschaftRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<SterbebildEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<SterbebildEigenschaftCreateInput>>;
};

export type SterbebildEigenschaftRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<SterbebildEigenschaftWhereUniqueInput>>;
  create?: InputMaybe<Array<SterbebildEigenschaftCreateInput>>;
  disconnect?: InputMaybe<Array<SterbebildEigenschaftWhereUniqueInput>>;
  set?: InputMaybe<Array<SterbebildEigenschaftWhereUniqueInput>>;
};

export type SterbebildEigenschaftUpdateArgs = {
  data: SterbebildEigenschaftUpdateInput;
  where: SterbebildEigenschaftWhereUniqueInput;
};

export type SterbebildEigenschaftUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objekte?: InputMaybe<ObjektRelateToManyForUpdateInput>;
};

export type SterbebildEigenschaftWhereInput = {
  AND?: InputMaybe<Array<SterbebildEigenschaftWhereInput>>;
  NOT?: InputMaybe<Array<SterbebildEigenschaftWhereInput>>;
  OR?: InputMaybe<Array<SterbebildEigenschaftWhereInput>>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  objekte?: InputMaybe<ObjektManyRelationFilter>;
};

export type SterbebildEigenschaftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isAuthor?: Maybe<Scalars['Boolean']['output']>;
  isEditor?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<PasswordState>;
};

export type UserAuthenticationWithPasswordFailure = {
  __typename?: 'UserAuthenticationWithPasswordFailure';
  message: Scalars['String']['output'];
};

export type UserAuthenticationWithPasswordResult = UserAuthenticationWithPasswordFailure | UserAuthenticationWithPasswordSuccess;

export type UserAuthenticationWithPasswordSuccess = {
  __typename?: 'UserAuthenticationWithPasswordSuccess';
  item: User;
  sessionToken: Scalars['String']['output'];
};

export type UserCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isEditor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  isAuthor?: InputMaybe<OrderDirection>;
  isEditor?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  isEditor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  isAuthor?: InputMaybe<BooleanFilter>;
  isEditor?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Zeitspanne = {
  __typename?: 'Zeitspanne';
  bis?: Maybe<Scalars['CalendarDay']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  von?: Maybe<Scalars['CalendarDay']['output']>;
};

export type ZeitspanneCreateInput = {
  bis?: InputMaybe<Scalars['CalendarDay']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  von?: InputMaybe<Scalars['CalendarDay']['input']>;
};

export type ZeitspanneOrderByInput = {
  bis?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
  von?: InputMaybe<OrderDirection>;
};

export type ZeitspanneRelateToOneForCreateInput = {
  connect?: InputMaybe<ZeitspanneWhereUniqueInput>;
  create?: InputMaybe<ZeitspanneCreateInput>;
};

export type ZeitspanneRelateToOneForUpdateInput = {
  connect?: InputMaybe<ZeitspanneWhereUniqueInput>;
  create?: InputMaybe<ZeitspanneCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZeitspanneUpdateArgs = {
  data: ZeitspanneUpdateInput;
  where: ZeitspanneWhereUniqueInput;
};

export type ZeitspanneUpdateInput = {
  bis?: InputMaybe<Scalars['CalendarDay']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  von?: InputMaybe<Scalars['CalendarDay']['input']>;
};

export type ZeitspanneWhereInput = {
  AND?: InputMaybe<Array<ZeitspanneWhereInput>>;
  NOT?: InputMaybe<Array<ZeitspanneWhereInput>>;
  OR?: InputMaybe<Array<ZeitspanneWhereInput>>;
  bis?: InputMaybe<CalendarDayNullableFilter>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
  von?: InputMaybe<CalendarDayNullableFilter>;
};

export type ZeitspanneWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetEventByIdQueryVariables = Exact<{
  where: EreignisWhereUniqueInput;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetEventByIdQuery = { __typename?: 'Query', event?: { __typename?: 'Ereignis', id: string, title?: string | null, subtitle?: string | null, description?: { __typename?: 'Ereignis_description_Document', document: any } | null, images?: Array<{ __typename?: 'Objekt', images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null }> | null, typen?: Array<{ __typename?: 'EreignisTyp', name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, place?: { __typename?: 'Ort', name?: string | null, id: string } | null, characters?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, partOf?: Array<{ __typename?: 'Ereignis', title?: string | null, id: string }> | null, contains?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, similarTo?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, weblinks?: { __typename?: 'Ereignis_weblinks_Document', document: any } | null } | null };

export type GetGroupByIdQueryVariables = Exact<{
  where: GruppeWhereUniqueInput;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetGroupByIdQuery = { __typename?: 'Query', group?: { __typename?: 'Gruppe', id: string, bezeichnung?: string | null, description?: { __typename?: 'Gruppe_description_Document', document: any } | null, otherTitles?: { __typename?: 'Gruppe_otherTitles_Document', document: any } | null, images?: Array<{ __typename?: 'Objekt', images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null }> | null, typen?: Array<{ __typename?: 'GruppenTyp', name?: string | null }> | null, characters?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, places?: Array<{ __typename?: 'Ort', name?: string | null, id: string }> | null, partOf?: Array<{ __typename?: 'Gruppe', bezeichnung?: string | null, id: string }> | null, objectAuthor?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, contains?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, owner?: Array<{ __typename?: 'Eigentum', id: string, displayName?: string | null }> | null, onEvents?: Array<{ __typename?: 'Ereignis', title?: string | null, id: string }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, weblinks?: { __typename?: 'Gruppe_weblinks_Document', document: any } | null } | null };

export type GetObjectItemsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ObjektEigenschaftVolkskundeWhereInput>;
}>;


export type GetObjectItemsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'ObjektEigenschaftVolkskunde', id: string, name?: string | null }> | null };

export type GetObjectMaterialsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ObjektEigenschaftMaterialWhereInput>;
}>;


export type GetObjectMaterialsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'ObjektEigenschaftMaterial', id: string, name?: string | null }> | null };

export type GetObjectPublicationsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ObjektEigenschaftPublikationWhereInput>;
}>;


export type GetObjectPublicationsQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'ObjektEigenschaftPublikation', id: string, name?: string | null }> | null };

export type GetObjectTechniquesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ObjektEigenschaftTechnikWhereInput>;
}>;


export type GetObjectTechniquesQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'ObjektEigenschaftTechnik', id: string, name?: string | null }> | null };

export type GetByIdQueryVariables = Exact<{
  where: ObjektWhereUniqueInput;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetByIdQuery = { __typename?: 'Query', object?: { __typename?: 'Objekt', title?: string | null, id: string, dimensions?: string | null, typ?: Array<{ __typename?: 'ObjektTyp', name?: string | null }> | null, description?: { __typename?: 'Objekt_description_Document', document: any } | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null, imageObjects?: Array<{ __typename?: 'Objekt', id: string, title?: string | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null }> | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, place?: { __typename?: 'Ort', id: string, name?: string | null } | null, ownerships?: Array<{ __typename?: 'Eigentum', displayName?: string | null }> | null, partOf?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, typ?: Array<{ __typename?: 'ObjektTyp', name?: string | null }> | null }> | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', bezeichnung?: string | null, displayName?: string | null, id: string }> | null, contains?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, weblinks?: { __typename?: 'Objekt_weblinks_Document', document: any } | null, eigenschaftenMaterial?: Array<{ __typename?: 'ObjektEigenschaftMaterial', name?: string | null }> | null, eigenschaftenTechnik?: Array<{ __typename?: 'ObjektEigenschaftTechnik', name?: string | null }> | null, similarTo?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, locationToday?: { __typename?: 'Ort', id: string, name?: string | null } | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null } | null };

export type GetObjectsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjektOrderByInput> | ObjektOrderByInput>;
  where?: InputMaybe<ObjektWhereInput>;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetObjectsQuery = { __typename?: 'Query', count?: number | null, items?: Array<{ __typename?: 'Objekt', id: string, title?: string | null, publisher?: string | null, pages?: string | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null, datum?: any | null, zeitspanne?: { __typename?: 'Zeitspanne', von?: any | null, bis?: any | null } | null } | null, imageObjects?: Array<{ __typename?: 'Objekt', id: string, title?: string | null, images?: Array<{ __typename?: 'Foto', displayName?: string | null, bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null }> | null }> | null }> | null };

export type GetPersonByIdQueryVariables = Exact<{
  where: PersonWhereUniqueInput;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetPersonByIdQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null, sex?: string | null, dateOfDeath?: any | null, dateOfBirth?: any | null, description?: { __typename?: 'Person_description_Document', document: any } | null, images?: Array<{ __typename?: 'Objekt', imageObjects?: Array<{ __typename?: 'Objekt', title?: string | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null }> | null }> | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null }> | null, occupation?: Array<{ __typename?: 'BerufsTyp', name?: string | null, weiblich?: string | null }> | null, nickname?: { __typename?: 'Person_nickname_Document', document: any } | null, periodOfDeath?: { __typename?: 'Entstehungszeit', zeitspanne?: { __typename?: 'Zeitspanne', von?: any | null, bis?: any | null } | null } | null, mother?: { __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null, dateOfDeath?: any | null, dateOfBirth?: any | null, sex?: string | null, periodOfDeath?: { __typename?: 'Entstehungszeit', zeitspanne?: { __typename?: 'Zeitspanne', von?: any | null, bis?: any | null } | null } | null } | null, father?: { __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null, dateOfDeath?: any | null, dateOfBirth?: any | null, sex?: string | null, periodOfDeath?: { __typename?: 'Entstehungszeit', zeitspanne?: { __typename?: 'Zeitspanne', von?: any | null, bis?: any | null } | null } | null } | null, fatherOf?: Array<{ __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null }> | null, motherOf?: Array<{ __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null }> | null, weddings?: Array<{ __typename?: 'Hochzeit', spouses?: Array<{ __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null }> | null }> | null, objectAuthor?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, weblinks?: { __typename?: 'Person_weblinks_Document', document: any } | null, eventCharacters?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, onEvent?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, groupCharacters?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null } | null };

export type GetPeopleQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PersonOrderByInput> | PersonOrderByInput>;
  where?: InputMaybe<PersonWhereInput>;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetPeopleQuery = { __typename?: 'Query', count?: number | null, items?: Array<{ __typename?: 'Person', id: string, familyName?: string | null, givenName?: string | null, displayName?: string | null, dateOfBirth?: any | null, dateOfDeath?: any | null, sex?: string | null, placeOfBirth?: { __typename?: 'Ort', displayName?: string | null } | null, images?: Array<{ __typename?: 'Objekt', imageObjects?: Array<{ __typename?: 'Objekt', title?: string | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null }> | null }> | null, images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null, zeitspanne?: { __typename?: 'Zeitspanne', von?: any | null, bis?: any | null } | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null }> | null, nickname?: { __typename?: 'Person_nickname_Document', document: any } | null, description?: { __typename?: 'Person_description_Document', document: any } | null }> | null };

export type GetPlaceTypesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrtTypWhereInput>;
}>;


export type GetPlaceTypesQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'OrtTyp', id: string, name?: string | null }> | null };

export type GetPlaceByIdQueryVariables = Exact<{
  where: OrtWhereUniqueInput;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetPlaceByIdQuery = { __typename?: 'Query', place?: { __typename?: 'Ort', name?: string | null, id: string, address?: string | null, nativeNames?: string | null, gps?: string | null, description?: { __typename?: 'Ort_description_Document', document: any } | null, typen?: Array<{ __typename?: 'OrtTyp', id: string }> | null, images?: { __typename?: 'Objekt', images?: Array<{ __typename?: 'Foto', bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null, objekte?: Array<{ __typename?: 'Objekt', title?: string | null, id: string, description?: { __typename?: 'Objekt_description_Document', document: any } | null, copyright?: Array<{ __typename?: 'CopyrightTyp', name?: string | null }> | null, images?: Array<{ __typename?: 'Foto', title?: string | null, name?: string | null }> | null, periodOfOrigin?: { __typename?: 'Entstehungszeit', displayName?: string | null } | null, authorPerson?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, authorGroup?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, personsOnWork?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, groupsOnWork?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null, locationOnWork?: Array<{ __typename?: 'Ort', id: string, name?: string | null }> | null }> | null }> | null } | null, area?: { __typename?: 'Gebiet', name?: string | null, teilVon?: { __typename?: 'Gebiet', name?: string | null } | null } | null, personenPlaceOfBirth?: Array<{ __typename?: 'Person', familyName?: string | null, givenName?: string | null, id: string }> | null, weblinks?: { __typename?: 'Ort_weblinks_Document', document: any } | null, objectPlace?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, objectLocationOnWork?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, objectLocationToday?: Array<{ __typename?: 'Objekt', id: string, title?: string | null }> | null, eventPlace?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, eventLocationOnEvent?: Array<{ __typename?: 'Ereignis', id: string, title?: string | null }> | null, groupPlaces?: Array<{ __typename?: 'Gruppe', id: string, bezeichnung?: string | null }> | null } | null };

export type GetPlacesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrtWhereInput>;
  hydrateRelationships: Scalars['Boolean']['input'];
}>;


export type GetPlacesQuery = { __typename?: 'Query', count?: number | null, items?: Array<{ __typename?: 'Ort', id: string, name?: string | null, gps?: string | null, address?: string | null, nativeNames?: string | null, area?: { __typename?: 'Gebiet', name?: string | null } | null, typen?: Array<{ __typename?: 'OrtTyp', id: string, name?: string | null }> | null, images?: { __typename?: 'Objekt', images?: Array<{ __typename?: 'Foto', displayName?: string | null, bild?: { __typename?: 'ImageFieldOutput', url: string, id: string } | null }> | null } | null, description?: { __typename?: 'Ort_description_Document', document: any } | null }> | null };

export type GetPlacePropertiesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrtsEigenschaftWhereInput>;
}>;


export type GetPlacePropertiesQuery = { __typename?: 'Query', items?: Array<{ __typename?: 'OrtsEigenschaft', id: string, name?: string | null }> | null };


export const GetEventByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EreignisWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"ereignis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weblinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}}]}}]}}]} as unknown as DocumentNode<GetEventByIdQuery, GetEventByIdQueryVariables>;
export const GetGroupByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroupById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GruppeWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"group"},"name":{"kind":"Name","value":"gruppe"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"otherTitles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"characters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectAuthor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weblinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}}]}}]}}]} as unknown as DocumentNode<GetGroupByIdQuery, GetGroupByIdQueryVariables>;
export const GetObjectItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetObjectItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektEigenschaftVolkskundeWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"objektEigenschaftVolkskundes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectItemsQuery, GetObjectItemsQueryVariables>;
export const GetObjectMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetObjectMaterials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektEigenschaftMaterialWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"objektEigenschaftMaterials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectMaterialsQuery, GetObjectMaterialsQueryVariables>;
export const GetObjectPublicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetObjectPublications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektEigenschaftPublikationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"objektEigenschaftPublikations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectPublicationsQuery, GetObjectPublicationsQueryVariables>;
export const GetObjectTechniquesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetObjectTechniques"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektEigenschaftTechnikWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"objektEigenschaftTechniks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetObjectTechniquesQuery, GetObjectTechniquesQueryVariables>;
export const GetByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetByID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"object"},"name":{"kind":"Name","value":"objekt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typ"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"}},{"kind":"Field","name":{"kind":"Name","value":"ownerships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"typ"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contains"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weblinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eigenschaftenMaterial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eigenschaftenTechnik"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationToday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetByIdQuery, GetByIdQueryVariables>;
export const GetObjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetObjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektOrderByInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ObjektWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"objektsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"objekts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"zeitspanne"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"von"}},{"kind":"Field","name":{"kind":"Name","value":"bis"}}]}},{"kind":"Field","name":{"kind":"Name","value":"datum"}}]}},{"kind":"Field","name":{"kind":"Name","value":"publisher"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"imageObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetObjectsQuery, GetObjectsQueryVariables>;
export const GetPersonByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"person"},"name":{"kind":"Name","value":"person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"occupation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weiblich"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nickname"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfDeath"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"periodOfDeath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeitspanne"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"von"}},{"kind":"Field","name":{"kind":"Name","value":"bis"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mother"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfDeath"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"periodOfDeath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeitspanne"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"von"}},{"kind":"Field","name":{"kind":"Name","value":"bis"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"father"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfDeath"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"periodOfDeath"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zeitspanne"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"von"}},{"kind":"Field","name":{"kind":"Name","value":"bis"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fatherOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"motherOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weddings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectAuthor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weblinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventCharacters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupCharacters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonByIdQuery, GetPersonByIdQueryVariables>;
export const GetPeopleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPeople"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonOrderByInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"peopleCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"people"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfDeath"}},{"kind":"Field","name":{"kind":"Name","value":"sex"}},{"kind":"Field","name":{"kind":"Name","value":"placeOfBirth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageObjects"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"zeitspanne"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"von"}},{"kind":"Field","name":{"kind":"Name","value":"bis"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nickname"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}}]}}]}}]} as unknown as DocumentNode<GetPeopleQuery, GetPeopleQueryVariables>;
export const GetPlaceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrtTypWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"ortTyps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlaceTypesQuery, GetPlaceTypesQueryVariables>;
export const GetPlaceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrtWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"place"},"name":{"kind":"Name","value":"ort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"typen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objekte"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"copyright"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodOfOrigin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authorGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupsOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"nativeNames"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teilVon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gps"}},{"kind":"Field","name":{"kind":"Name","value":"personenPlaceOfBirth"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weblinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectPlace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectLocationOnWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectLocationToday"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventPlace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventLocationOnEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupPlaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bezeichnung"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlaceByIdQuery, GetPlaceByIdQueryVariables>;
export const GetPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrtWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"ortsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]},{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"orts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gps"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"typen"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"bild"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nativeNames"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hydrateRelationships"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hydrateRelationships"}}}]}]}}]}}]}}]} as unknown as DocumentNode<GetPlacesQuery, GetPlacesQueryVariables>;
export const GetPlacePropertiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceProperties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrtsEigenschaftWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"items"},"name":{"kind":"Name","value":"ortsEigenschafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlacePropertiesQuery, GetPlacePropertiesQueryVariables>;